import React from 'react';
import { getBrowserLanguage } from './detect.js';
import { savePreference, UI_LANGUAGE_KEY } from './preferences.js';

export const UI_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'bg', name: 'Български', flag: '🇧🇬' },
  { code: 'hy', name: 'Հայերէն', flag: '🇦🇲' },
];

export const UI_TRANSLATIONS = {
  fr: {
    distributorsTitle: 'Distributeurs',
    distributorsDefaultTitle: 'Votre distributeur',
    distributorsLoading: 'Chargement des distributeurs…',
    distributorsErrorPrefix: 'Erreur :',
    distributorsErrorLoad: 'Impossible de charger les distributeurs.',
    distributorsEmpty: 'Aucun distributeur pour cette sélection.',
    distributorsSelectPrompt: 'Choisissez un type et un continent pour afficher les distributeurs.',
    editoTocTitle: 'Sommaire',
    editoTocHistory: 'Notre histoire',
    collectionSearchPlaceholder: 'Rechercher un livre…',
    collectionSearchButton: 'Rechercher',
    collectionSearchResultsFor: 'Résultats pour',
    editoTocAuthor: "L'auteur",

    cardLabelEdito: 'Édito',

    cardPinnedHint: 'Cadre déplié — cliquer pour replier',

    cardUnpinnedHint: 'Cadre replié — cliquer pour déplier',
    editoTocThought: 'Pensée du jour',
    collectionCardTitle: 'Nos livres',
    collectionSelectLabel: 'Collection',
    collectionLanguageLabel: 'Langue',
    collectionLoading: 'Chargement des publications…',
    collectionErrorPrefix: 'Erreur :',
    collectionErrorLoad: 'Impossible de charger les publications.',
    collectionEmpty: 'Aucune publication pour cette sélection.',
    collectionInProgress: 'Catalogue en cours de constitution : de nouveaux titres sont ajoutés régulièrement.',
    bookNotFoundTitle: 'Livre introuvable',
    bookNotFoundMessage: "Ce livre n'existe pas ou n'est plus disponible.",
    bookBackHome: "Retour à l'accueil",
    collectionAll: 'Toutes les collections',
    breadcrumbHome: 'Accueil',
    breadcrumbLabel: "Fil d'Ariane",
    bookContentsTitle: 'Sommaire',
    bookRelatedTitle: 'Produits associés',
    bookTranslationsTitle: 'Traductions disponibles',
    bookDistributorsTitle: 'Où trouver ce livre',
    bookViewBuyLabel: 'Voir / Acheter',
    bookVisitSiteLabel: 'Visiter le site',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Autres partenaires',
    distributorLabelPublisher: 'Éditeur',
    distributorLabelWorldPublisher: 'Éditeur mondial',
    distributorLabelDistributor: 'Distributeur',
    distributorLabelDiffuser: 'Diffuseur',
    continentEurope: 'Europe',
    continentAmerica: 'Amérique',
    continentAfrica: 'Afrique',
    continentMiddleEast: 'Moyen-Orient',
    continentAsia: 'Asie',
    continentOceania: 'Océanie',
    scrollToTopLabel: 'Remonter en haut de la page',
    languageSelectorLabel: 'Langue',
    thoughtLoading: 'Chargement de la pensée…',
    thoughtErrorLoad: 'Impossible de charger la pensée.',
    thoughtErrorPrefix: 'Erreur :',
    thoughtSubscribeTitle: 'Abonnez-vous et recevez chaque jour une pensée inspirante de l\'auteur',
    thoughtSubscribeEmailPlaceholder: 'votre@email.com',
    thoughtSubscribeMathQuestion: 'Calcul anti-robot :',
    thoughtSubscribeMathPlaceholder: 'Réponse',
    thoughtSubscribeButton: 'S’abonner',
    thoughtSubscribeSending: 'Envoi...',
    thoughtSubscribeSuccess: 'Merci, votre demande d’abonnement a bien été envoyée.',
    thoughtSubscribeConfirmEmail: 'Pour finaliser votre inscription, veuillez cliquer sur le lien du message que vous allez recevoir.<br/>Vérifiez vos filtres anti-spam et autorisez l\'adresse "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Veuillez renseigner une adresse email valide.',
    thoughtSubscribeMathRequired: 'Veuillez répondre au calcul anti-robot.',
    thoughtSubscribeMathIncorrect: 'La réponse au calcul est incorrecte.',
    thoughtSubscribeTooFastError: 'Veuillez attendre quelques secondes avant de soumettre.',
    thoughtSubscribeSpamDetected: 'Soumission refusée : détection de comportement automatique.',
    thoughtSubscribeNetworkError: 'Impossible de se connecter au serveur. Vérifiez votre connexion et le certificat SSL.',
    thoughtSubscribeSubmitError: 'Impossible de soumettre le formulaire d’abonnement.',
    thoughtCaptchaRequired: 'Veuillez remplir le captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Saisissez le texte du captcha',
    thoughtCaptchaImageAlt: 'Captcha image',
    subscriptionsListLink: 'Liste de vos abonnements',
    subscriptionsListIntro: 'Saisissez votre adresse email : nous vous enverrons un lien pour consulter et gérer vos abonnements.',
    subscriptionsListSubmit: 'Recevoir le lien',
    subscriptionsListSent: 'Si cette adresse est abonnée, un email contenant le lien vers vos abonnements vient de lui être envoyé.',
    subscriptionsListError: "L'envoi est impossible pour le moment. Réessayez plus tard.",
    subscriptionsListTooMany: 'Trop de demandes. Réessayez dans quelques minutes.',
    subscriptionsMailSubject: 'Vos abonnements Prosveta',
    subscriptionsMailIntro: 'Bonjour,\n\nPour consulter et gérer vos abonnements Prosveta, ouvrez ce lien :',
    subscriptionsMailIgnore: "Si vous n'êtes pas à l'origine de cette demande, ignorez simplement ce message.",


    thoughtListenLoading: 'Chargement…',


    thoughtListenError: 'Lecture impossible',

    thoughtListenUnavailable: 'Lecture vocale indisponible',

    audioPlay: 'Lecture',

    audioPause: 'Pause',

    audioStop: 'Arrêter',

    audioSeek: 'Position de lecture',

    audioSpeed: 'Vitesse de lecture',



    contentLoading: 'Chargement du contenu…',
    contentErrorLoad: 'Erreur de chargement du contenu.',
    contentErrorPrefix: 'Erreur :',
    sliderLoading: 'Chargement du slider…',
    sliderErrorTitle: 'Erreur',
    sliderPrevLabel: 'Image précédente',
    sliderNextLabel: 'Image suivante',
    subscriptionStatusSubscribed: 'Votre inscription a été validée, vous recevrez la pensée quotidienne dès demain.',
    subscriptionStatusAlreadySubscribed: 'Vous êtes déjà inscrit sur cette liste.',
    subscriptionStatusGeneralError: 'Une erreur s’est produite.',
    subscriptionsMissingParams: 'Lien invalide : les paramètres email ou clé sont manquants.',
    subscriptionsLoadError: 'Impossible de charger vos abonnements.',
    subscriptionsModalTitle: 'Vos abonnements',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Abonnement à la pensée quotidienne',
    subscriptionsLanguageLabel: 'Langues :',
    subscriptionsFormatLabel: 'Format :',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Texte',
    subscriptionsUpdateButton: 'Mettre à jour',
    subscriptionsDeleteAllButton: 'Supprimer tout',
    subscriptionsCancelButton: 'Annuler',
    subscriptionsUpdateSuccess: 'Vos abonnements ont été mis à jour.',
    subscriptionsDeleteAllSuccess: 'Tous vos abonnements ont été supprimés.',
    subscriptionsUpdateError: 'Impossible de mettre à jour vos abonnements.',
    footerLegalNoticeLink: 'Mentions légales',
    footerPrivacyPolicyLink: 'Données personnelles',
    footerRightsReserved: 'Tous droits réservés.',
    footerCloseLabel: 'Fermer',
    footerCookieSettingsLink: 'Gérer les cookies',
    themeToggleDark: 'Activer le mode sombre',
    themeToggleLight: 'Activer le mode clair',
    cookieBannerMessage: 'Nous utilisons des cookies et du stockage local pour assurer le bon fonctionnement du site et, si vous l’acceptez, mesurer notre audience. Vous pouvez accepter, refuser ou personnaliser vos choix à tout moment.',
    cookieBannerAcceptAll: 'Tout accepter',
    cookieBannerRejectAll: 'Tout refuser',
    cookieBannerCustomize: 'Personnaliser',
    cookiePrefsTitle: 'Gestion des cookies',
    cookiePrefsIntro: 'Choisissez les catégories de cookies que vous souhaitez autoriser. Vous pouvez modifier vos préférences à tout moment depuis le pied de page du site.',
    cookieCategoryNecessaryTitle: 'Cookies nécessaires',
    cookieCategoryNecessaryDesc: 'Indispensables au fonctionnement du site, notamment pour mémoriser votre langue de navigation. Ils ne peuvent pas être désactivés.',
    cookieCategoryAnalyticsTitle: 'Mesure d’audience',
    cookieCategoryAnalyticsDesc: 'Nous aident à comprendre la fréquentation du site (pages consultées, provenance des visites) afin de l’améliorer. Désactivés par défaut.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Utilisés pour mesurer l’efficacité de nos communications. Désactivés par défaut et non utilisés actuellement.',
    cookiePrefsSave: 'Enregistrer mes choix',
    cookieAlwaysActive: 'Toujours actif',
  },
  en: {
    distributorsTitle: 'Distributors',
    distributorsDefaultTitle: 'Your distributor',
    distributorsLoading: 'Loading distributors…',
    distributorsErrorPrefix: 'Error:',
    distributorsErrorLoad: 'Unable to load distributors.',
    distributorsEmpty: 'No distributor for this selection.',
    distributorsSelectPrompt: 'Choose a type and a continent to display the distributors.',
    editoTocTitle: 'Contents',
    editoTocHistory: 'Our history',
    collectionSearchPlaceholder: 'Search for a book…',
    collectionSearchButton: 'Search',
    collectionSearchResultsFor: 'Results for',
    editoTocAuthor: 'The author',

    cardLabelEdito: 'Editorial',

    cardPinnedHint: 'Panel open — click to collapse',

    cardUnpinnedHint: 'Panel closed — click to expand',
    editoTocThought: 'Thought of the day',
    collectionCardTitle: 'Our books',
    collectionSelectLabel: 'Collection',
    collectionLanguageLabel: 'Language',
    collectionLoading: 'Loading publications…',
    collectionErrorPrefix: 'Error:',
    collectionErrorLoad: 'Unable to load publications.',
    collectionEmpty: 'No publications for this selection.',
    collectionInProgress: 'Catalogue under construction: new titles are added regularly.',
    bookNotFoundTitle: 'Book not found',
    bookNotFoundMessage: 'This book does not exist or is no longer available.',
    bookBackHome: 'Back to home',
    collectionAll: 'All collections',
    breadcrumbHome: 'Home',
    breadcrumbLabel: 'Breadcrumb',
    bookContentsTitle: 'Contents',
    bookRelatedTitle: 'Related products',
    bookTranslationsTitle: 'Available translations',
    bookDistributorsTitle: 'Where to find this book',
    bookViewBuyLabel: 'View / Buy',
    bookVisitSiteLabel: 'Visit site',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Other partners',
    distributorLabelPublisher: 'Publisher',
    distributorLabelWorldPublisher: 'World publisher',
    distributorLabelDistributor: 'Distributor',
    distributorLabelDiffuser: 'Sales agent',
    continentEurope: 'Europe',
    continentAmerica: 'America',
    continentAfrica: 'Africa',
    continentMiddleEast: 'Middle East',
    continentAsia: 'Asia',
    continentOceania: 'Oceania',
    scrollToTopLabel: 'Back to top',
    languageSelectorLabel: 'Language',
    thoughtLoading: 'Loading the thought…',
    thoughtErrorLoad: 'Unable to load the thought.',
    thoughtErrorPrefix: 'Error:',
    thoughtSubscribeTitle: 'Subscribe and receive an inspiring thought from the author every day',
    thoughtSubscribeEmailPlaceholder: 'your@email.com',
    thoughtSubscribeMathQuestion: 'Anti-bot math:',
    thoughtSubscribeMathPlaceholder: 'Answer',
    thoughtSubscribeButton: 'Subscribe',
    thoughtSubscribeSending: 'Sending...',
    thoughtSubscribeSuccess: 'Thank you, your subscription request has been sent.',
    thoughtSubscribeConfirmEmail: 'To complete your subscription, please click the link in the message you will receive.<br/>Check your spam filters and allow the address "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Please enter a valid email address.',
    thoughtSubscribeMathRequired: 'Please answer the anti-bot math question.',
    thoughtSubscribeMathIncorrect: 'The math answer is incorrect.',
    thoughtSubscribeTooFastError: 'Please wait a few seconds before submitting.',
    thoughtSubscribeSpamDetected: 'Submission blocked: automated activity detected.',
    thoughtSubscribeNetworkError: 'Unable to connect to the server. Please check your connection and SSL certificate.',
    thoughtSubscribeSubmitError: 'Unable to submit the subscription form.',
    thoughtCaptchaRequired: 'Please fill in the captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Enter the captcha text',
    thoughtCaptchaImageAlt: 'Captcha image',
    subscriptionsListLink: 'Your subscriptions',
    subscriptionsListIntro: 'Enter your email address: we will send you a link to view and manage your subscriptions.',
    subscriptionsListSubmit: 'Send me the link',
    subscriptionsListSent: 'If this address is subscribed, an email with the link to your subscriptions has just been sent to it.',
    subscriptionsListError: 'Sending is not possible right now. Please try again later.',
    subscriptionsListTooMany: 'Too many requests. Please try again in a few minutes.',
    subscriptionsMailSubject: 'Your Prosveta subscriptions',
    subscriptionsMailIntro: 'Hello,\n\nTo view and manage your Prosveta subscriptions, open this link:',
    subscriptionsMailIgnore: 'If you did not make this request, simply ignore this message.',


    thoughtListenLoading: 'Loading…',


    thoughtListenError: 'Playback failed',

    thoughtListenUnavailable: 'Voice playback unavailable',

    audioPlay: 'Play',

    audioPause: 'Pause',

    audioStop: 'Stop',

    audioSeek: 'Playback position',

    audioSpeed: 'Playback speed',



    contentLoading: 'Loading content…',
    contentErrorLoad: 'Unable to load content.',
    contentErrorPrefix: 'Error:',
    sliderLoading: 'Loading slider…',
    sliderErrorTitle: 'Error',
    sliderPrevLabel: 'Previous slide',
    sliderNextLabel: 'Next slide',
    subscriptionStatusSubscribed: 'Your subscription has been confirmed, you will receive the daily thought starting tomorrow.',
    subscriptionStatusAlreadySubscribed: 'You are already subscribed to this list.',
    subscriptionStatusGeneralError: 'An error occurred.',
    subscriptionsMissingParams: 'Invalid link: the email or key parameters are missing.',
    subscriptionsLoadError: 'Unable to load your subscriptions.',
    subscriptionsModalTitle: 'Your subscriptions',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Subscription to the daily thought',
    subscriptionsLanguageLabel: 'Languages:',
    subscriptionsFormatLabel: 'Format:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Text',
    subscriptionsUpdateButton: 'Update',
    subscriptionsDeleteAllButton: 'Delete all',
    subscriptionsCancelButton: 'Cancel',
    subscriptionsUpdateSuccess: 'Your subscriptions have been updated.',
    subscriptionsDeleteAllSuccess: 'All your subscriptions have been removed.',
    subscriptionsUpdateError: 'Unable to update your subscriptions.',
    footerLegalNoticeLink: 'Legal notice',
    footerPrivacyPolicyLink: 'Personal data',
    footerRightsReserved: 'All rights reserved.',
    footerCloseLabel: 'Close',
    footerCookieSettingsLink: 'Cookie settings',
    themeToggleDark: 'Switch to dark mode',
    themeToggleLight: 'Switch to light mode',
    cookieBannerMessage: 'We use cookies and local storage to keep the site running smoothly and, if you agree, to measure our audience. You can accept, decline, or customize your choices at any time.',
    cookieBannerAcceptAll: 'Accept all',
    cookieBannerRejectAll: 'Reject all',
    cookieBannerCustomize: 'Customize',
    cookiePrefsTitle: 'Cookie settings',
    cookiePrefsIntro: 'Choose which categories of cookies you want to allow. You can change your preferences at any time from the website footer.',
    cookieCategoryNecessaryTitle: 'Necessary cookies',
    cookieCategoryNecessaryDesc: 'Required for the website to function, in particular to remember your browsing language. These cannot be disabled.',
    cookieCategoryAnalyticsTitle: 'Analytics',
    cookieCategoryAnalyticsDesc: 'Help us understand how the site is used (pages viewed, traffic sources) so we can improve it. Disabled by default.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Used to measure the effectiveness of our communications. Disabled by default and not currently in use.',
    cookiePrefsSave: 'Save my choices',
    cookieAlwaysActive: 'Always active',
  },
  de: {
    distributorsTitle: 'Vertriebspartner',
    distributorsDefaultTitle: 'Ihr Vertriebspartner',
    distributorsLoading: 'Vertriebspartner werden geladen…',
    distributorsErrorPrefix: 'Fehler:',
    distributorsErrorLoad: 'Vertriebspartner konnten nicht geladen werden.',
    distributorsEmpty: 'Kein Vertriebspartner für diese Auswahl.',
    distributorsSelectPrompt: 'Wählen Sie einen Typ und einen Kontinent, um die Vertriebspartner anzuzeigen.',
    editoTocTitle: 'Inhalt',
    editoTocHistory: 'Unsere Geschichte',
    collectionSearchPlaceholder: 'Ein Buch suchen…',
    collectionSearchButton: 'Suchen',
    collectionSearchResultsFor: 'Ergebnisse für',
    editoTocAuthor: 'Der Autor',

    cardLabelEdito: 'Editorial',

    cardPinnedHint: 'Bereich geöffnet — klicken zum Einklappen',

    cardUnpinnedHint: 'Bereich eingeklappt — klicken zum Öffnen',
    editoTocThought: 'Gedanke des Tages',
    collectionCardTitle: 'Unsere Bücher',
    collectionSelectLabel: 'Kollektion',
    collectionLanguageLabel: 'Sprache',
    collectionLoading: 'Publikationen werden geladen…',
    collectionErrorPrefix: 'Fehler:',
    collectionErrorLoad: 'Publikationen konnten nicht geladen werden.',
    collectionEmpty: 'Keine Publikationen für diese Auswahl.',
    collectionInProgress: 'Katalog im Aufbau: Regelmäßig kommen neue Titel hinzu.',
    bookNotFoundTitle: 'Buch nicht gefunden',
    bookNotFoundMessage: 'Dieses Buch existiert nicht mehr oder ist nicht verfügbar.',
    bookBackHome: 'Zurück zur Startseite',
    collectionAll: 'Alle Kollektionen',
    breadcrumbHome: 'Startseite',
    breadcrumbLabel: 'Brotkrümelnavigation',
    bookContentsTitle: 'Inhaltsverzeichnis',
    bookRelatedTitle: 'Verwandte Produkte',
    bookTranslationsTitle: 'Verfügbare Übersetzungen',
    bookDistributorsTitle: 'Wo Sie dieses Buch finden',
    bookViewBuyLabel: 'Ansehen / Kaufen',
    bookVisitSiteLabel: 'Website besuchen',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Weitere Partner',
    distributorLabelPublisher: 'Verlag',
    distributorLabelWorldPublisher: 'Weltverlag',
    distributorLabelDistributor: 'Vertrieb',
    distributorLabelDiffuser: 'Verlagsvertretung',
    continentEurope: 'Europa',
    continentAmerica: 'Amerika',
    continentAfrica: 'Afrika',
    continentMiddleEast: 'Naher Osten',
    continentAsia: 'Asien',
    continentOceania: 'Ozeanien',
    scrollToTopLabel: 'Nach oben',
    languageSelectorLabel: 'Sprache',
    thoughtLoading: 'Gedanke wird geladen…',
    thoughtErrorLoad: 'Gedanke konnte nicht geladen werden.',
    thoughtErrorPrefix: 'Fehler:',
    thoughtSubscribeTitle: 'Abonnieren Sie und erhalten Sie jeden Tag einen inspirierenden Gedanken des Autors',
    thoughtSubscribeEmailPlaceholder: 'ihre@email.de',
    thoughtSubscribeMathQuestion: 'Anti-Bot-Rechnung:',
    thoughtSubscribeMathPlaceholder: 'Antwort',
    thoughtSubscribeButton: 'Abonnieren',
    thoughtSubscribeSending: 'Senden...',
    thoughtSubscribeSuccess: 'Danke, Ihre Abonnement-Anfrage wurde gesendet.',
    thoughtSubscribeConfirmEmail: 'Um Ihre Anmeldung abzuschließen, klicken Sie bitte auf den Link in der Nachricht, die Sie erhalten werden.<br/>Überprüfen Sie Ihre Spam-Filter und lassen Sie die Adresse „no-reply@prosveta.com" zu.',
    thoughtSubscribeInvalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    thoughtSubscribeMathRequired: 'Bitte beantworten Sie die Anti-Bot-Rechenaufgabe.',
    thoughtSubscribeMathIncorrect: 'Die Rechenantwort ist falsch.',
    thoughtSubscribeTooFastError: 'Bitte warten Sie einige Sekunden, bevor Sie absenden.',
    thoughtSubscribeSpamDetected: 'Übermittlung blockiert: Automatisierte Aktivität erkannt.',
    thoughtSubscribeNetworkError: 'Verbindung zum Server fehlgeschlagen. Bitte prüfen Sie Ihre Verbindung und das SSL-Zertifikat.',
    thoughtSubscribeSubmitError: 'Das Abonnementformular konnte nicht gesendet werden.',
    thoughtCaptchaRequired: 'Bitte füllen Sie das Captcha aus.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Geben Sie den Captcha-Text ein',
    thoughtCaptchaImageAlt: 'Captcha-Bild',
    subscriptionsListLink: 'Ihre Abonnements',
    subscriptionsListIntro: 'Geben Sie Ihre E-Mail-Adresse ein: Wir senden Ihnen einen Link, um Ihre Abonnements einzusehen und zu verwalten.',
    subscriptionsListSubmit: 'Link erhalten',
    subscriptionsListSent: 'Falls diese Adresse abonniert ist, wurde soeben eine E-Mail mit dem Link zu Ihren Abonnements an sie gesendet.',
    subscriptionsListError: 'Der Versand ist derzeit nicht möglich. Bitte versuchen Sie es später erneut.',
    subscriptionsListTooMany: 'Zu viele Anfragen. Bitte versuchen Sie es in einigen Minuten erneut.',
    subscriptionsMailSubject: 'Ihre Prosveta-Abonnements',
    subscriptionsMailIntro: 'Guten Tag,\n\nUm Ihre Prosveta-Abonnements einzusehen und zu verwalten, öffnen Sie diesen Link:',
    subscriptionsMailIgnore: 'Falls Sie diese Anfrage nicht gestellt haben, ignorieren Sie diese Nachricht einfach.',


    thoughtListenLoading: 'Lade…',


    thoughtListenError: 'Wiedergabe fehlgeschlagen',

    thoughtListenUnavailable: 'Sprachwiedergabe nicht verfügbar',

    audioPlay: 'Abspielen',

    audioPause: 'Pause',

    audioStop: 'Stoppen',

    audioSeek: 'Wiedergabeposition',

    audioSpeed: 'Wiedergabegeschwindigkeit',



    contentLoading: 'Inhalt wird geladen…',
    contentErrorLoad: 'Inhalt konnte nicht geladen werden.',
    contentErrorPrefix: 'Fehler:',
    sliderLoading: 'Slider wird geladen…',
    sliderErrorTitle: 'Fehler',
    sliderPrevLabel: 'Vorheriges Bild',
    sliderNextLabel: 'Nächstes Bild',
    subscriptionStatusSubscribed: 'Ihre Anmeldung wurde bestätigt, Sie erhalten den täglichen Gedanken ab morgen.',
    subscriptionStatusAlreadySubscribed: 'Sie sind bereits für diese Liste angemeldet.',
    subscriptionStatusGeneralError: 'Ein Fehler ist aufgetreten.',
    subscriptionsUpdateButton: 'Aktualisieren',
    subscriptionsDeleteAllButton: 'Alle löschen',
    subscriptionsCancelButton: 'Abbrechen',
    subscriptionsUpdateSuccess: 'Ihre Abonnements wurden aktualisiert.',
    subscriptionsDeleteAllSuccess: 'Alle Ihre Abonnements wurden entfernt.',
    subscriptionsUpdateError: 'Ihre Abonnements konnten nicht aktualisiert werden.',
    subscriptionsModalTitle: 'Ihre Abonnements',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Abonnement des täglichen Gedankens',
    subscriptionsLanguageLabel: 'Sprachen:',
    subscriptionsFormatLabel: 'Format:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Text',
    footerLegalNoticeLink: 'Impressum',
    footerPrivacyPolicyLink: 'Datenschutz',
    footerRightsReserved: 'Alle Rechte vorbehalten.',
    footerCloseLabel: 'Schließen',
    footerCookieSettingsLink: 'Cookie-Einstellungen',
    themeToggleDark: 'Dunkelmodus aktivieren',
    themeToggleLight: 'Hellmodus aktivieren',
    cookieBannerMessage: 'Wir verwenden Cookies und lokalen Speicher, damit die Website reibungslos funktioniert, und – mit Ihrer Zustimmung – um unsere Zugriffe zu messen. Sie können Ihre Wahl jederzeit akzeptieren, ablehnen oder anpassen.',
    cookieBannerAcceptAll: 'Alle akzeptieren',
    cookieBannerRejectAll: 'Alle ablehnen',
    cookieBannerCustomize: 'Anpassen',
    cookiePrefsTitle: 'Cookie-Einstellungen',
    cookiePrefsIntro: 'Wählen Sie aus, welche Cookie-Kategorien Sie zulassen möchten. Sie können Ihre Einstellungen jederzeit über die Fußzeile der Website ändern.',
    cookieCategoryNecessaryTitle: 'Notwendige Cookies',
    cookieCategoryNecessaryDesc: 'Erforderlich für den Betrieb der Website, insbesondere um Ihre Sprache zu merken. Diese können nicht deaktiviert werden.',
    cookieCategoryAnalyticsTitle: 'Reichweitenmessung',
    cookieCategoryAnalyticsDesc: 'Helfen uns zu verstehen, wie die Website genutzt wird (aufgerufene Seiten, Herkunft der Besuche), um sie zu verbessern. Standardmäßig deaktiviert.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Dienen zur Messung der Wirksamkeit unserer Kommunikation. Standardmäßig deaktiviert und derzeit nicht verwendet.',
    cookiePrefsSave: 'Auswahl speichern',
    cookieAlwaysActive: 'Immer aktiv',
  },
  es: {
    distributorsTitle: 'Distribuidores',
    distributorsDefaultTitle: 'Su distribuidor',
    distributorsLoading: 'Cargando distribuidores…',
    distributorsErrorPrefix: 'Error:',
    distributorsErrorLoad: 'No se pudieron cargar los distribuidores.',
    distributorsEmpty: 'Ningún distribuidor para esta selección.',
    distributorsSelectPrompt: 'Elige un tipo y un continente para mostrar los distribuidores.',
    editoTocTitle: 'Índice',
    editoTocHistory: 'Nuestra historia',
    collectionSearchPlaceholder: 'Buscar un libro…',
    collectionSearchButton: 'Buscar',
    collectionSearchResultsFor: 'Resultados para',
    editoTocAuthor: 'El autor',

    cardLabelEdito: 'Editorial',

    cardPinnedHint: 'Panel desplegado — clic para plegar',

    cardUnpinnedHint: 'Panel plegado — clic para desplegar',
    editoTocThought: 'Pensamiento del día',
    collectionCardTitle: 'Nuestros libros',
    collectionSelectLabel: 'Colección',
    collectionLanguageLabel: 'Idioma',
    collectionLoading: 'Cargando publicaciones…',
    collectionErrorPrefix: 'Error:',
    collectionErrorLoad: 'No se pudieron cargar las publicaciones.',
    collectionEmpty: 'No hay publicaciones para esta selección.',
    collectionInProgress: 'Catálogo en construcción: se añaden nuevos títulos regularmente.',
    bookNotFoundTitle: 'Libro no encontrado',
    bookNotFoundMessage: 'Este libro no existe o ya no está disponible.',
    bookBackHome: 'Volver al inicio',
    collectionAll: 'Todas las colecciones',
    breadcrumbHome: 'Inicio',
    breadcrumbLabel: 'Ruta de navegación',
    bookContentsTitle: 'Índice',
    bookRelatedTitle: 'Productos relacionados',
    bookTranslationsTitle: 'Traducciones disponibles',
    bookDistributorsTitle: 'Dónde encontrar este libro',
    bookViewBuyLabel: 'Ver / Comprar',
    bookVisitSiteLabel: 'Visitar el sitio',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Otros socios',
    distributorLabelPublisher: 'Editorial',
    distributorLabelWorldPublisher: 'Editorial mundial',
    distributorLabelDistributor: 'Distribuidor',
    distributorLabelDiffuser: 'Agente comercial',
    continentEurope: 'Europa',
    continentAmerica: 'América',
    continentAfrica: 'África',
    continentMiddleEast: 'Oriente Medio',
    continentAsia: 'Asia',
    continentOceania: 'Oceanía',
    scrollToTopLabel: 'Volver arriba',
    languageSelectorLabel: 'Idioma',
    thoughtLoading: 'Cargando el pensamiento…',
    thoughtErrorLoad: 'No se puede cargar el pensamiento.',
    thoughtErrorPrefix: 'Error:',
    thoughtSubscribeTitle: 'Suscríbete y recibe cada día un pensamiento inspirador del autor',
    thoughtSubscribeEmailPlaceholder: 'tu@correo.com',
    thoughtSubscribeMathQuestion: 'Cálculo anti-bot:',
    thoughtSubscribeMathPlaceholder: 'Respuesta',
    thoughtSubscribeButton: 'Suscribirse',
    thoughtSubscribeSending: 'Enviando...',
    thoughtSubscribeSuccess: 'Gracias, su solicitud de suscripción ha sido enviada.',
    thoughtSubscribeConfirmEmail: 'Para finalizar tu inscripción, haz clic en el enlace del mensaje que recibirás.<br/>Verifica tus filtros antispam y autoriza la dirección "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Por favor, introduce una dirección de correo electrónico válida.',
    thoughtSubscribeMathRequired: 'Por favor responde la pregunta matemática anti-bot.',
    thoughtSubscribeMathIncorrect: 'La respuesta matemática es incorrecta.',
    thoughtSubscribeTooFastError: 'Por favor espera unos segundos antes de enviar.',
    thoughtSubscribeSpamDetected: 'Envío bloqueado: actividad automatizada detectada.',
    thoughtSubscribeNetworkError: 'No se pudo conectar al servidor. Verifica tu conexión y el certificado SSL.',
    thoughtSubscribeSubmitError: 'No se pudo enviar el formulario de suscripción.',
    thoughtCaptchaRequired: 'Por favor, completa el captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Introduce el texto del captcha',
    thoughtCaptchaImageAlt: 'Imagen del captcha',
    subscriptionsListLink: 'Sus suscripciones',
    subscriptionsListIntro: 'Introduzca su dirección de correo: le enviaremos un enlace para consultar y gestionar sus suscripciones.',
    subscriptionsListSubmit: 'Recibir el enlace',
    subscriptionsListSent: 'Si esta dirección está suscrita, se le acaba de enviar un correo con el enlace a sus suscripciones.',
    subscriptionsListError: 'El envío no es posible en este momento. Inténtelo de nuevo más tarde.',
    subscriptionsListTooMany: 'Demasiadas solicitudes. Inténtelo de nuevo en unos minutos.',
    subscriptionsMailSubject: 'Sus suscripciones Prosveta',
    subscriptionsMailIntro: 'Hola:\n\nPara consultar y gestionar sus suscripciones Prosveta, abra este enlace:',
    subscriptionsMailIgnore: 'Si usted no ha realizado esta solicitud, simplemente ignore este mensaje.',


    thoughtListenLoading: 'Cargando…',


    thoughtListenError: 'No se pudo reproducir',

    thoughtListenUnavailable: 'Lectura en voz no disponible',

    audioPlay: 'Reproducir',

    audioPause: 'Pausa',

    audioStop: 'Detener',

    audioSeek: 'Posición de reproducción',

    audioSpeed: 'Velocidad de reproducción',



    contentLoading: 'Cargando el contenido…',
    contentErrorLoad: 'No se puede cargar el contenido.',
    contentErrorPrefix: 'Error:',
    sliderLoading: 'Cargando el slider…',
    sliderErrorTitle: 'Error',
    sliderPrevLabel: 'Imagen anterior',
    sliderNextLabel: 'Siguiente imagen',
    subscriptionStatusSubscribed: 'Tu inscripción ha sido validada, recibirás el pensamiento diario a partir de mañana.',
    subscriptionStatusAlreadySubscribed: 'Ya estás inscrito en esta lista.',
    subscriptionStatusGeneralError: 'Se ha producido un error.',
    subscriptionsUpdateButton: 'Actualizar',
    subscriptionsDeleteAllButton: 'Eliminar todo',
    subscriptionsCancelButton: 'Cancelar',
    subscriptionsUpdateSuccess: 'Sus suscripciones han sido actualizadas.',
    subscriptionsDeleteAllSuccess: 'Se han eliminado todas sus suscripciones.',
    subscriptionsUpdateError: 'No se pudieron actualizar sus suscripciones.',
    subscriptionsModalTitle: 'Sus suscripciones',
    subscriptionsNewsletterLabel: 'Boletín',
    subscriptionsGroupTitle: 'Suscripción al pensamiento diario',
    subscriptionsLanguageLabel: 'Idiomas:',
    subscriptionsFormatLabel: 'Formato:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Texto',
    footerLegalNoticeLink: 'Aviso legal',
    footerPrivacyPolicyLink: 'Datos personales',
    footerRightsReserved: 'Todos los derechos reservados.',
    footerCloseLabel: 'Cerrar',
    footerCookieSettingsLink: 'Configuración de cookies',
    themeToggleDark: 'Activar modo oscuro',
    themeToggleLight: 'Activar modo claro',
    cookieBannerMessage: 'Utilizamos cookies y almacenamiento local para que el sitio funcione correctamente y, si lo aceptas, para medir nuestra audiencia. Puedes aceptar, rechazar o personalizar tus opciones en cualquier momento.',
    cookieBannerAcceptAll: 'Aceptar todo',
    cookieBannerRejectAll: 'Rechazar todo',
    cookieBannerCustomize: 'Personalizar',
    cookiePrefsTitle: 'Configuración de cookies',
    cookiePrefsIntro: 'Elige las categorías de cookies que deseas permitir. Puedes cambiar tus preferencias en cualquier momento desde el pie de página del sitio.',
    cookieCategoryNecessaryTitle: 'Cookies necesarias',
    cookieCategoryNecessaryDesc: 'Imprescindibles para el funcionamiento del sitio, en particular para recordar tu idioma de navegación. No se pueden desactivar.',
    cookieCategoryAnalyticsTitle: 'Medición de audiencia',
    cookieCategoryAnalyticsDesc: 'Nos ayudan a entender el uso del sitio (páginas vistas, origen de las visitas) para mejorarlo. Desactivadas por defecto.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Se utilizan para medir la eficacia de nuestras comunicaciones. Desactivadas por defecto y no utilizadas actualmente.',
    cookiePrefsSave: 'Guardar mis opciones',
    cookieAlwaysActive: 'Siempre activas',
  },
  it: {
    distributorsTitle: 'Distributori',
    distributorsDefaultTitle: 'Il tuo distributore',
    distributorsLoading: 'Caricamento dei distributori…',
    distributorsErrorPrefix: 'Errore:',
    distributorsErrorLoad: 'Impossibile caricare i distributori.',
    distributorsEmpty: 'Nessun distributore per questa selezione.',
    distributorsSelectPrompt: 'Scegli un tipo e un continente per visualizzare i distributori.',
    editoTocTitle: 'Sommario',
    editoTocHistory: 'La nostra storia',
    collectionSearchPlaceholder: 'Cerca un libro…',
    collectionSearchButton: 'Cerca',
    collectionSearchResultsFor: 'Risultati per',
    editoTocAuthor: "L'autore",

    cardLabelEdito: 'Editoriale',

    cardPinnedHint: 'Riquadro aperto — clic per chiudere',

    cardUnpinnedHint: 'Riquadro chiuso — clic per aprire',
    editoTocThought: 'Pensiero del giorno',
    collectionCardTitle: 'I nostri libri',
    collectionSelectLabel: 'Collezione',
    collectionLanguageLabel: 'Lingua',
    collectionLoading: 'Caricamento delle pubblicazioni…',
    collectionErrorPrefix: 'Errore:',
    collectionErrorLoad: 'Impossibile caricare le pubblicazioni.',
    collectionEmpty: 'Nessuna pubblicazione per questa selezione.',
    collectionInProgress: 'Catalogo in costruzione: nuovi titoli vengono aggiunti regolarmente.',
    bookNotFoundTitle: 'Libro non trovato',
    bookNotFoundMessage: 'Questo libro non esiste o non è più disponibile.',
    bookBackHome: 'Torna alla home',
    collectionAll: 'Tutte le collezioni',
    breadcrumbHome: 'Home',
    breadcrumbLabel: 'Percorso di navigazione',
    bookContentsTitle: 'Sommario',
    bookRelatedTitle: 'Prodotti correlati',
    bookTranslationsTitle: 'Traduzioni disponibili',
    bookDistributorsTitle: 'Dove trovare questo libro',
    bookViewBuyLabel: 'Vedi / Acquista',
    bookVisitSiteLabel: 'Visita il sito',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Altri partner',
    distributorLabelPublisher: 'Editore',
    distributorLabelWorldPublisher: 'Editore mondiale',
    distributorLabelDistributor: 'Distributore',
    distributorLabelDiffuser: 'Promotore',
    continentEurope: 'Europa',
    continentAmerica: 'America',
    continentAfrica: 'Africa',
    continentMiddleEast: 'Medio Oriente',
    continentAsia: 'Asia',
    continentOceania: 'Oceania',
    scrollToTopLabel: 'Torna su',
    languageSelectorLabel: 'Lingua',
    thoughtLoading: 'Caricamento del pensiero…',
    thoughtErrorLoad: 'Impossibile caricare il pensiero.',
    thoughtErrorPrefix: 'Errore:',
    thoughtSubscribeTitle: 'Iscriviti e ricevi ogni giorno un pensiero ispiratore dell\'autore',
    thoughtSubscribeEmailPlaceholder: 'tuo@email.com',
    thoughtSubscribeMathQuestion: 'Calcolo anti-bot:',
    thoughtSubscribeMathPlaceholder: 'Risposta',
    thoughtSubscribeButton: 'Iscriviti',
    thoughtSubscribeSending: 'Invio...',
    thoughtSubscribeSuccess: 'Grazie, la tua richiesta di iscrizione è stata inviata.',
    thoughtSubscribeConfirmEmail: 'Per completare la tua iscrizione, clicca sul link nel messaggio che riceverai.<br/>Controlla i filtri antispam e autorizza l\'indirizzo "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Per favore inserisci un indirizzo email valido.',
    thoughtSubscribeMathRequired: 'Si prega di rispondere alla domanda matematica anti-bot.',
    thoughtSubscribeMathIncorrect: 'La risposta matematica non è corretta.',
    thoughtSubscribeTooFastError: 'Attendere qualche secondo prima di inviare.',
    thoughtSubscribeSpamDetected: 'Invio bloccato: attività automatizzata rilevata.',
    thoughtSubscribeNetworkError: 'Impossibile connettersi al server. Verifica la tua connessione e il certificato SSL.',
    thoughtSubscribeSubmitError: 'Impossibile inviare il modulo di iscrizione.',
    thoughtCaptchaRequired: 'Per favore, completa il captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Inserisci il testo del captcha',
    thoughtCaptchaImageAlt: 'Immagine captcha',
    subscriptionsListLink: 'I vostri abbonamenti',
    subscriptionsListIntro: 'Inserite il vostro indirizzo email: vi invieremo un link per consultare e gestire i vostri abbonamenti.',
    subscriptionsListSubmit: 'Ricevi il link',
    subscriptionsListSent: "Se questo indirizzo è iscritto, gli è appena stata inviata un'email con il link ai vostri abbonamenti.",
    subscriptionsListError: "L'invio non è possibile al momento. Riprovate più tardi.",
    subscriptionsListTooMany: 'Troppe richieste. Riprovate tra qualche minuto.',
    subscriptionsMailSubject: 'I vostri abbonamenti Prosveta',
    subscriptionsMailIntro: 'Buongiorno,\n\nPer consultare e gestire i vostri abbonamenti Prosveta, aprite questo link:',
    subscriptionsMailIgnore: 'Se non avete fatto voi questa richiesta, ignorate semplicemente questo messaggio.',


    thoughtListenLoading: 'Caricamento…',


    thoughtListenError: 'Riproduzione non riuscita',

    thoughtListenUnavailable: 'Lettura vocale non disponibile',

    audioPlay: 'Riproduci',

    audioPause: 'Pausa',

    audioStop: 'Ferma',

    audioSeek: 'Posizione di riproduzione',

    audioSpeed: 'Velocità di riproduzione',



    contentLoading: 'Caricamento del contenuto…',
    contentErrorLoad: 'Impossibile caricare il contenuto.',
    contentErrorPrefix: 'Errore:',
    sliderLoading: 'Caricamento dello slider…',
    sliderErrorTitle: 'Errore',
    sliderPrevLabel: 'Immagine precedente',
    sliderNextLabel: 'Immagine successiva',
    subscriptionStatusSubscribed: 'La tua iscrizione è stata convalidata, riceverai il pensiero quotidiano a partire da domani.',
    subscriptionStatusAlreadySubscribed: 'Sei già iscritto a questa lista.',
    subscriptionStatusGeneralError: 'Si è verificato un errore.',
    subscriptionsUpdateButton: 'Aggiorna',
    subscriptionsDeleteAllButton: 'Elimina tutto',
    subscriptionsCancelButton: 'Annulla',
    subscriptionsUpdateSuccess: 'I tuoi abbonamenti sono stati aggiornati.',
    subscriptionsDeleteAllSuccess: 'Tutti i tuoi abbonamenti sono stati rimossi.',
    subscriptionsUpdateError: 'Impossibile aggiornare i tuoi abbonamenti.',
    subscriptionsModalTitle: 'I tuoi abbonamenti',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Abbonamento al pensiero quotidiano',
    subscriptionsLanguageLabel: 'Lingue:',
    subscriptionsFormatLabel: 'Formato:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Testo',
    footerLegalNoticeLink: 'Note legali',
    footerPrivacyPolicyLink: 'Dati personali',
    footerRightsReserved: 'Tutti i diritti riservati.',
    footerCloseLabel: 'Chiudi',
    footerCookieSettingsLink: 'Impostazioni cookie',
    themeToggleDark: 'Attiva modalità scura',
    themeToggleLight: 'Attiva modalità chiara',
    cookieBannerMessage: 'Utilizziamo cookie e archiviazione locale per garantire il corretto funzionamento del sito e, con il tuo consenso, per misurare l’audience. Puoi accettare, rifiutare o personalizzare le tue scelte in qualsiasi momento.',
    cookieBannerAcceptAll: 'Accetta tutto',
    cookieBannerRejectAll: 'Rifiuta tutto',
    cookieBannerCustomize: 'Personalizza',
    cookiePrefsTitle: 'Impostazioni cookie',
    cookiePrefsIntro: 'Scegli le categorie di cookie che desideri consentire. Puoi modificare le tue preferenze in qualsiasi momento dal piè di pagina del sito.',
    cookieCategoryNecessaryTitle: 'Cookie necessari',
    cookieCategoryNecessaryDesc: 'Indispensabili per il funzionamento del sito, in particolare per ricordare la lingua di navigazione. Non possono essere disattivati.',
    cookieCategoryAnalyticsTitle: 'Misurazione dell’audience',
    cookieCategoryAnalyticsDesc: 'Ci aiutano a capire come viene utilizzato il sito (pagine visualizzate, provenienza delle visite) per migliorarlo. Disattivati per impostazione predefinita.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Utilizzati per misurare l’efficacia delle nostre comunicazioni. Disattivati per impostazione predefinita e non attualmente utilizzati.',
    cookiePrefsSave: 'Salva le mie scelte',
    cookieAlwaysActive: 'Sempre attivi',
  },
  pt: {
    distributorsTitle: 'Distribuidores',
    distributorsDefaultTitle: 'O seu distribuidor',
    distributorsLoading: 'Carregando distribuidores…',
    distributorsErrorPrefix: 'Erro:',
    distributorsErrorLoad: 'Não foi possível carregar os distribuidores.',
    distributorsEmpty: 'Nenhum distribuidor para esta seleção.',
    distributorsSelectPrompt: 'Escolha um tipo e um continente para exibir os distribuidores.',
    editoTocTitle: 'Índice',
    editoTocHistory: 'A nossa história',
    collectionSearchPlaceholder: 'Pesquisar um livro…',
    collectionSearchButton: 'Pesquisar',
    collectionSearchResultsFor: 'Resultados para',
    editoTocAuthor: 'O autor',

    cardLabelEdito: 'Editorial',

    cardPinnedHint: 'Painel aberto — clique para recolher',

    cardUnpinnedHint: 'Painel recolhido — clique para expandir',
    editoTocThought: 'Pensamento do dia',
    collectionCardTitle: 'Os nossos livros',
    collectionSelectLabel: 'Coleção',
    collectionLanguageLabel: 'Idioma',
    collectionLoading: 'Carregando publicações…',
    collectionErrorPrefix: 'Erro:',
    collectionErrorLoad: 'Não foi possível carregar as publicações.',
    collectionEmpty: 'Nenhuma publicação para esta seleção.',
    collectionInProgress: 'Catálogo em construção: novos títulos são adicionados regularmente.',
    bookNotFoundTitle: 'Livro não encontrado',
    bookNotFoundMessage: 'Este livro não existe ou já não está disponível.',
    bookBackHome: 'Voltar ao início',
    collectionAll: 'Todas as coleções',
    breadcrumbHome: 'Início',
    breadcrumbLabel: 'Navegação estrutural',
    bookContentsTitle: 'Índice',
    bookRelatedTitle: 'Produtos relacionados',
    bookTranslationsTitle: 'Traduções disponíveis',
    bookDistributorsTitle: 'Onde encontrar este livro',
    bookViewBuyLabel: 'Ver / Comprar',
    bookVisitSiteLabel: 'Visitar o site',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Outros parceiros',
    distributorLabelPublisher: 'Editora',
    distributorLabelWorldPublisher: 'Editora mundial',
    distributorLabelDistributor: 'Distribuidor',
    distributorLabelDiffuser: 'Agente comercial',
    continentEurope: 'Europa',
    continentAmerica: 'América',
    continentAfrica: 'África',
    continentMiddleEast: 'Médio Oriente',
    continentAsia: 'Ásia',
    continentOceania: 'Oceania',
    scrollToTopLabel: 'Voltar ao topo',
    languageSelectorLabel: 'Idioma',
    thoughtLoading: 'Carregando o pensamento…',
    thoughtErrorLoad: 'Não foi possível carregar o pensamento.',
    thoughtErrorPrefix: 'Erro:',
    thoughtSubscribeTitle: 'Inscreva-se e receba todos os dias um pensamento inspirador do autor',
    thoughtSubscribeEmailPlaceholder: 'seu@email.com',
    thoughtSubscribeButton: 'Inscrever-se',
    thoughtSubscribeSending: 'Enviando...',
    thoughtSubscribeSuccess: 'Obrigado, sua solicitação de inscrição foi enviada.',
    thoughtSubscribeConfirmEmail: 'Para finalizar a sua inscrição, clique no link da mensagem que irá receber.<br/>Verifique os seus filtros de spam e autorize o endereço "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Por favor insira um endereço de email válido.',
    thoughtSubscribeMathQuestion: 'Cálculo anti-bot:',
    thoughtSubscribeMathPlaceholder: 'Resposta',
    thoughtSubscribeMathRequired: 'Por favor responda ao cálculo anti-bot.',
    thoughtSubscribeMathIncorrect: 'A resposta do cálculo está incorreta.',
    thoughtSubscribeTooFastError: 'Por favor espere alguns segundos antes de enviar.',
    thoughtSubscribeSpamDetected: 'Envio bloqueado: atividade automatizada detectada.',
    thoughtSubscribeNetworkError: 'Não foi possível conectar ao servidor. Verifique sua conexão e o certificado SSL.',
    thoughtSubscribeSubmitError: 'Não foi possível enviar o formulário de inscrição.',
    thoughtCaptchaRequired: 'Por favor, preencha o captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Insira o texto do captcha',
    thoughtCaptchaImageAlt: 'Imagem do captcha',
    subscriptionsListLink: 'As suas subscrições',
    subscriptionsListIntro: 'Introduza o seu endereço de email: enviaremos uma ligação para consultar e gerir as suas subscrições.',
    subscriptionsListSubmit: 'Receber a ligação',
    subscriptionsListSent: 'Se este endereço estiver subscrito, acaba de lhe ser enviado um email com a ligação para as suas subscrições.',
    subscriptionsListError: 'Não é possível enviar neste momento. Tente novamente mais tarde.',
    subscriptionsListTooMany: 'Demasiados pedidos. Tente novamente dentro de alguns minutos.',
    subscriptionsMailSubject: 'As suas subscrições Prosveta',
    subscriptionsMailIntro: 'Olá,\n\nPara consultar e gerir as suas subscrições Prosveta, abra esta ligação:',
    subscriptionsMailIgnore: 'Se não fez este pedido, ignore simplesmente esta mensagem.',


    thoughtListenLoading: 'Carregando…',


    thoughtListenError: 'Não foi possível reproduzir',

    thoughtListenUnavailable: 'Leitura em voz indisponível',

    audioPlay: 'Reproduzir',

    audioPause: 'Pausar',

    audioStop: 'Parar',

    audioSeek: 'Posição de reprodução',

    audioSpeed: 'Velocidade de reprodução',



    contentLoading: 'Carregando o conteúdo…',
    contentErrorLoad: 'Não foi possível carregar o conteúdo.',
    contentErrorPrefix: 'Erro:',
    sliderLoading: 'Carregando o slider…',
    sliderErrorTitle: 'Erro',
    sliderPrevLabel: 'Slide anterior',
    sliderNextLabel: 'Próximo slide',
    subscriptionStatusSubscribed: 'A sua inscrição foi validada, receberá o pensamento diário a partir de amanhã.',
    subscriptionStatusAlreadySubscribed: 'Já está inscrito nesta lista.',
    subscriptionStatusGeneralError: 'Ocorreu um erro.',
    subscriptionsUpdateButton: 'Atualizar',
    subscriptionsDeleteAllButton: 'Eliminar tudo',
    subscriptionsCancelButton: 'Cancelar',
    subscriptionsUpdateSuccess: 'As suas subscrições foram atualizadas.',
    subscriptionsDeleteAllSuccess: 'Todas as suas subscrições foram removidas.',
    subscriptionsUpdateError: 'Não foi possível atualizar as suas subscrições.',
    subscriptionsModalTitle: 'As suas subscrições',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Subscrição do pensamento diário',
    subscriptionsLanguageLabel: 'Idiomas:',
    subscriptionsFormatLabel: 'Formato:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Texto',
    footerLegalNoticeLink: 'Aviso legal',
    footerPrivacyPolicyLink: 'Dados pessoais',
    footerRightsReserved: 'Todos os direitos reservados.',
    footerCloseLabel: 'Fechar',
    footerCookieSettingsLink: 'Definições de cookies',
    themeToggleDark: 'Ativar modo escuro',
    themeToggleLight: 'Ativar modo claro',
    cookieBannerMessage: 'Utilizamos cookies e armazenamento local para garantir o bom funcionamento do site e, com o seu consentimento, medir a nossa audiência. Pode aceitar, recusar ou personalizar as suas escolhas a qualquer momento.',
    cookieBannerAcceptAll: 'Aceitar tudo',
    cookieBannerRejectAll: 'Recusar tudo',
    cookieBannerCustomize: 'Personalizar',
    cookiePrefsTitle: 'Definições de cookies',
    cookiePrefsIntro: 'Escolha as categorias de cookies que deseja permitir. Pode alterar as suas preferências a qualquer momento a partir do rodapé do site.',
    cookieCategoryNecessaryTitle: 'Cookies necessários',
    cookieCategoryNecessaryDesc: 'Indispensáveis para o funcionamento do site, nomeadamente para memorizar o seu idioma de navegação. Não podem ser desativados.',
    cookieCategoryAnalyticsTitle: 'Medição de audiência',
    cookieCategoryAnalyticsDesc: 'Ajudam-nos a compreender a utilização do site (páginas visualizadas, origem das visitas) para o melhorar. Desativados por predefinição.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Utilizados para medir a eficácia das nossas comunicações. Desativados por predefinição e não utilizados atualmente.',
    cookiePrefsSave: 'Guardar as minhas escolhas',
    cookieAlwaysActive: 'Sempre ativos',
  },
  nl: {
    distributorsTitle: 'Distributeurs',
    distributorsDefaultTitle: 'Uw distributeur',
    distributorsLoading: 'Distributeurs laden…',
    distributorsErrorPrefix: 'Fout:',
    distributorsErrorLoad: 'Distributeurs konden niet worden geladen.',
    distributorsEmpty: 'Geen distributeur voor deze selectie.',
    distributorsSelectPrompt: 'Kies een type en een continent om de distributeurs weer te geven.',
    editoTocTitle: 'Inhoud',
    editoTocHistory: 'Onze geschiedenis',
    collectionSearchPlaceholder: 'Zoek een boek…',
    collectionSearchButton: 'Zoeken',
    collectionSearchResultsFor: 'Resultaten voor',
    editoTocAuthor: 'De auteur',

    cardLabelEdito: 'Redactioneel',

    cardPinnedHint: 'Kader open — klik om in te klappen',

    cardUnpinnedHint: 'Kader dicht — klik om te openen',
    editoTocThought: 'Gedachte van de dag',
    collectionCardTitle: 'Onze boeken',
    collectionSelectLabel: 'Collectie',
    collectionLanguageLabel: 'Taal',
    collectionLoading: 'Publicaties laden…',
    collectionErrorPrefix: 'Fout:',
    collectionErrorLoad: 'Publicaties konden niet worden geladen.',
    collectionEmpty: 'Geen publicaties voor deze selectie.',
    collectionInProgress: 'Catalogus in opbouw: er worden regelmatig nieuwe titels toegevoegd.',
    bookNotFoundTitle: 'Boek niet gevonden',
    bookNotFoundMessage: 'Dit boek bestaat niet meer of is niet beschikbaar.',
    bookBackHome: 'Terug naar home',
    collectionAll: 'Alle collecties',
    breadcrumbHome: 'Home',
    breadcrumbLabel: 'Kruimelpad',
    bookContentsTitle: 'Inhoud',
    bookRelatedTitle: 'Gerelateerde producten',
    bookTranslationsTitle: 'Beschikbare vertalingen',
    bookDistributorsTitle: 'Waar dit boek te vinden is',
    bookViewBuyLabel: 'Bekijken / Kopen',
    bookVisitSiteLabel: 'Website bezoeken',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Andere partners',
    distributorLabelPublisher: 'Uitgever',
    distributorLabelWorldPublisher: 'Wereldwijde uitgever',
    distributorLabelDistributor: 'Distributeur',
    distributorLabelDiffuser: 'Vertegenwoordiger',
    continentEurope: 'Europa',
    continentAmerica: 'Amerika',
    continentAfrica: 'Afrika',
    continentMiddleEast: 'Midden-Oosten',
    continentAsia: 'Azië',
    continentOceania: 'Oceanië',
    scrollToTopLabel: 'Naar boven',
    languageSelectorLabel: 'Taal',
    thoughtLoading: 'Gedachte laden…',
    thoughtErrorLoad: 'Gedachte kon niet worden geladen.',
    thoughtErrorPrefix: 'Fout:',
    thoughtSubscribeTitle: 'Abonneer je en ontvang elke dag een inspirerende gedachte van de auteur',
    thoughtSubscribeEmailPlaceholder: 'jouw@email.com',
    thoughtSubscribeButton: 'Abonneren',
    thoughtSubscribeSending: 'Verzenden...',
    thoughtSubscribeSuccess: 'Bedankt, uw abonnement is verzonden.',
    thoughtSubscribeConfirmEmail: 'Om uw inschrijving te voltooien, klik op de link in het bericht dat u zult ontvangen.<br/>Controleer uw spamfilters en sta het adres "no-reply@prosveta.com" toe.',
    thoughtSubscribeInvalidEmail: 'Voer een geldig e-mailadres in.',
    thoughtSubscribeMathQuestion: 'Anti-bot rekensom:',
    thoughtSubscribeMathPlaceholder: 'Antwoord',
    thoughtSubscribeMathRequired: 'Beantwoord de anti-bot rekensom.',
    thoughtSubscribeMathIncorrect: 'Het antwoord is onjuist.',
    thoughtSubscribeTooFastError: 'Wacht een paar seconden voordat je indient.',
    thoughtSubscribeSpamDetected: 'Verzending geblokkeerd: geautomatiseerde activiteit gedetecteerd.',
    thoughtSubscribeNetworkError: 'Kon geen verbinding maken met de server. Controleer je verbinding en het SSL-certificaat.',
    thoughtSubscribeSubmitError: 'Het abonnement formulier kon niet worden verzonden.',
    thoughtCaptchaRequired: 'Vul het captcha in.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Voer de tekst van het captcha in',
    thoughtCaptchaImageAlt: 'Captcha afbeelding',
    subscriptionsListLink: 'Uw abonnementen',
    subscriptionsListIntro: 'Vul uw e-mailadres in: we sturen u een link om uw abonnementen te bekijken en te beheren.',
    subscriptionsListSubmit: 'Link ontvangen',
    subscriptionsListSent: 'Als dit adres geabonneerd is, is er zojuist een e-mail met de link naar uw abonnementen naartoe gestuurd.',
    subscriptionsListError: 'Verzenden is op dit moment niet mogelijk. Probeer het later opnieuw.',
    subscriptionsListTooMany: 'Te veel aanvragen. Probeer het over enkele minuten opnieuw.',
    subscriptionsMailSubject: 'Uw Prosveta-abonnementen',
    subscriptionsMailIntro: 'Hallo,\n\nOm uw Prosveta-abonnementen te bekijken en te beheren, opent u deze link:',
    subscriptionsMailIgnore: 'Als u deze aanvraag niet hebt gedaan, kunt u dit bericht gewoon negeren.',


    thoughtListenLoading: 'Laden…',


    thoughtListenError: 'Afspelen mislukt',

    thoughtListenUnavailable: 'Voorlezen niet beschikbaar',

    audioPlay: 'Afspelen',

    audioPause: 'Pauzeren',

    audioStop: 'Stoppen',

    audioSeek: 'Afspeelpositie',

    audioSpeed: 'Afspeelsnelheid',



    contentLoading: 'Inhoud wordt geladen…',
    contentErrorLoad: 'Inhoud kon niet worden geladen.',
    contentErrorPrefix: 'Fout:',
    sliderLoading: 'Slider wordt geladen…',
    sliderErrorTitle: 'Fout',
    sliderPrevLabel: 'Vorige afbeelding',
    sliderNextLabel: 'Volgende afbeelding',
    subscriptionStatusSubscribed: 'Uw inschrijving is bevestigd, u ontvangt de dagelijkse gedachte vanaf morgen.',
    subscriptionStatusAlreadySubscribed: 'U bent al ingeschreven op deze lijst.',
    subscriptionStatusGeneralError: 'Er is een fout opgetreden.',
    subscriptionsUpdateButton: 'Bijwerken',
    subscriptionsDeleteAllButton: 'Alles verwijderen',
    subscriptionsCancelButton: 'Annuleren',
    subscriptionsUpdateSuccess: 'Uw abonnementen zijn bijgewerkt.',
    subscriptionsDeleteAllSuccess: 'Al uw abonnementen zijn verwijderd.',
    subscriptionsUpdateError: 'Uw abonnementen konden niet worden bijgewerkt.',
    subscriptionsModalTitle: 'Uw abonnementen',
    subscriptionsNewsletterLabel: 'Nieuwsbrief',
    subscriptionsGroupTitle: 'Abonnement op de dagelijkse gedachte',
    subscriptionsLanguageLabel: 'Talen:',
    subscriptionsFormatLabel: 'Formaat:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Tekst',
    footerLegalNoticeLink: 'Juridische vermeldingen',
    footerPrivacyPolicyLink: 'Persoonsgegevens',
    footerRightsReserved: 'Alle rechten voorbehouden.',
    footerCloseLabel: 'Sluiten',
    footerCookieSettingsLink: 'Cookie-instellingen',
    themeToggleDark: 'Donkere modus inschakelen',
    themeToggleLight: 'Lichte modus inschakelen',
    cookieBannerMessage: 'We gebruiken cookies en lokale opslag om de website goed te laten werken en, met uw toestemming, om ons bezoekersaantal te meten. U kunt uw keuzes op elk moment accepteren, weigeren of aanpassen.',
    cookieBannerAcceptAll: 'Alles accepteren',
    cookieBannerRejectAll: 'Alles weigeren',
    cookieBannerCustomize: 'Aanpassen',
    cookiePrefsTitle: 'Cookie-instellingen',
    cookiePrefsIntro: 'Kies welke cookiecategorieën u wilt toestaan. U kunt uw voorkeuren op elk moment wijzigen via de voettekst van de website.',
    cookieCategoryNecessaryTitle: 'Noodzakelijke cookies',
    cookieCategoryNecessaryDesc: 'Noodzakelijk voor de werking van de website, met name om uw taal te onthouden. Deze kunnen niet worden uitgeschakeld.',
    cookieCategoryAnalyticsTitle: 'Bezoekersanalyse',
    cookieCategoryAnalyticsDesc: 'Helpen ons te begrijpen hoe de site wordt gebruikt (bekeken pagina’s, herkomst van bezoeken) om deze te verbeteren. Standaard uitgeschakeld.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Worden gebruikt om de effectiviteit van onze communicatie te meten. Standaard uitgeschakeld en momenteel niet gebruikt.',
    cookiePrefsSave: 'Mijn keuzes opslaan',
    cookieAlwaysActive: 'Altijd actief',
  },
  ro: {
    distributorsTitle: 'Distribuitori',
    distributorsDefaultTitle: 'Distribuitorul dvs.',
    distributorsLoading: 'Se încarcă distribuitorii…',
    distributorsErrorPrefix: 'Eroare:',
    distributorsErrorLoad: 'Distribuitorii nu au putut fi încărcați.',
    distributorsEmpty: 'Niciun distribuitor pentru această selecție.',
    distributorsSelectPrompt: 'Alegeți un tip și un continent pentru a afișa distribuitorii.',
    editoTocTitle: 'Cuprins',
    editoTocHistory: 'Istoria noastră',
    collectionSearchPlaceholder: 'Caută o carte…',
    collectionSearchButton: 'Caută',
    collectionSearchResultsFor: 'Rezultate pentru',
    editoTocAuthor: 'Autorul',

    cardLabelEdito: 'Editorial',

    cardPinnedHint: 'Panou deschis — click pentru a restrânge',

    cardUnpinnedHint: 'Panou restrâns — click pentru a deschide',
    editoTocThought: 'Gândul zilei',
    collectionCardTitle: 'Cărțile noastre',
    collectionSelectLabel: 'Colecție',
    collectionLanguageLabel: 'Limbă',
    collectionLoading: 'Se încarcă publicațiile…',
    collectionErrorPrefix: 'Eroare:',
    collectionErrorLoad: 'Publicațiile nu au putut fi încărcate.',
    collectionEmpty: 'Nicio publicație pentru această selecție.',
    collectionInProgress: 'Catalog în curs de constituire: se adaugă regulat titluri noi.',
    bookNotFoundTitle: 'Carte negăsită',
    bookNotFoundMessage: 'Această carte nu există sau nu mai este disponibilă.',
    bookBackHome: 'Înapoi la pagina principală',
    collectionAll: 'Toate colecțiile',
    breadcrumbHome: 'Acasă',
    breadcrumbLabel: 'Traseu de navigare',
    bookContentsTitle: 'Cuprins',
    bookRelatedTitle: 'Produse asociate',
    bookTranslationsTitle: 'Traduceri disponibile',
    bookDistributorsTitle: 'Unde găsiți această carte',
    bookViewBuyLabel: 'Vezi / Cumpără',
    bookVisitSiteLabel: 'Vizitează site-ul',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Alți parteneri',
    distributorLabelPublisher: 'Editură',
    distributorLabelWorldPublisher: 'Editură mondială',
    distributorLabelDistributor: 'Distribuitor',
    distributorLabelDiffuser: 'Agent de vânzări',
    continentEurope: 'Europa',
    continentAmerica: 'America',
    continentAfrica: 'Africa',
    continentMiddleEast: 'Orientul Mijlociu',
    continentAsia: 'Asia',
    continentOceania: 'Oceania',
    scrollToTopLabel: 'Înapoi sus',
    languageSelectorLabel: 'Limbă',
    thoughtLoading: 'Se încarcă gândul…',
    thoughtErrorLoad: 'Nu se poate încărca gândul.',
    thoughtErrorPrefix: 'Eroare:',
    thoughtSubscribeTitle: 'Abonați-vă și primiți în fiecare zi un gând inspirat de autor',
    thoughtSubscribeEmailPlaceholder: 'adresa@ta.ro',
    thoughtSubscribeButton: 'Abonați-vă',
    thoughtSubscribeSending: 'Se trimite...',
    thoughtSubscribeSuccess: 'Mulțumim, cererea dvs. de abonare a fost trimisă.',
    thoughtSubscribeConfirmEmail: 'Pentru a finaliza înscrierea, vă rugăm să faceți clic pe linkul din mesajul pe care îl veți primi.<br/>Verificați filtrele anti-spam și autorizați adresa "no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Vă rugăm să introduceți o adresă de email validă.',
    thoughtSubscribeMathQuestion: 'Calcul anti-bot:',
    thoughtSubscribeMathPlaceholder: 'Răspuns',
    thoughtSubscribeMathRequired: 'Vă rugăm să răspundeți la calculul anti-bot.',
    thoughtSubscribeMathIncorrect: 'Răspunsul la calcul este incorect.',
    thoughtSubscribeTooFastError: 'Vă rugăm să așteptați câteva secunde înainte de a trimite.',
    thoughtSubscribeSpamDetected: 'Trimitere blocată: activitate automată detectată.',
    thoughtSubscribeNetworkError: 'Nu s-a putut conecta la server. Verificați conexiunea și certificatul SSL.',
    thoughtSubscribeSubmitError: 'Nu s-a putut trimite formularul de abonare.',
    thoughtCaptchaRequired: 'Vă rugăm să completați captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Introduceți textul captcha',
    thoughtCaptchaImageAlt: 'Imagine captcha',
    subscriptionsListLink: 'Abonamentele dumneavoastră',
    subscriptionsListIntro: 'Introduceți adresa de email: vă vom trimite un link pentru a vă consulta și gestiona abonamentele.',
    subscriptionsListSubmit: 'Primiți linkul',
    subscriptionsListSent: 'Dacă această adresă este abonată, tocmai i-a fost trimis un email cu linkul către abonamentele dumneavoastră.',
    subscriptionsListError: 'Trimiterea nu este posibilă momentan. Încercați din nou mai târziu.',
    subscriptionsListTooMany: 'Prea multe cereri. Încercați din nou peste câteva minute.',
    subscriptionsMailSubject: 'Abonamentele dumneavoastră Prosveta',
    subscriptionsMailIntro: 'Bună ziua,\n\nPentru a vă consulta și gestiona abonamentele Prosveta, deschideți acest link:',
    subscriptionsMailIgnore: 'Dacă nu ați făcut această cerere, ignorați pur și simplu acest mesaj.',


    thoughtListenLoading: 'Se încarcă…',


    thoughtListenError: 'Redarea a eșuat',

    thoughtListenUnavailable: 'Citirea vocală indisponibilă',

    audioPlay: 'Redare',

    audioPause: 'Pauză',

    audioStop: 'Oprește',

    audioSeek: 'Poziția de redare',

    audioSpeed: 'Viteza de redare',



    contentLoading: 'Se încarcă conținutul…',
    contentErrorLoad: 'Nu se poate încărca conținutul.',
    contentErrorPrefix: 'Eroare:',
    sliderLoading: 'Se încarcă sliderul…',
    sliderErrorTitle: 'Eroare',
    sliderPrevLabel: 'Imagine anterioară',
    sliderNextLabel: 'Următoarea imagine',
    subscriptionStatusSubscribed: 'Înscrierea dvs. a fost validată, veți primi gândul zilnic începând de mâine.',
    subscriptionStatusAlreadySubscribed: 'Sunteți deja înscris pe această listă.',
    subscriptionStatusGeneralError: 'A apărut o eroare.',
    subscriptionsUpdateButton: 'Actualizează',
    subscriptionsDeleteAllButton: 'Șterge tot',
    subscriptionsCancelButton: 'Anulează',
    subscriptionsUpdateSuccess: 'Abonamentele dvs. au fost actualizate.',
    subscriptionsDeleteAllSuccess: 'Toate abonamentele dvs. au fost eliminate.',
    subscriptionsUpdateError: 'Abonamentele dvs. nu au putut fi actualizate.',
    subscriptionsModalTitle: 'Abonamentele dvs.',
    subscriptionsNewsletterLabel: 'Newsletter',
    subscriptionsGroupTitle: 'Abonament la gândul zilnic',
    subscriptionsLanguageLabel: 'Limbi:',
    subscriptionsFormatLabel: 'Format:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Text',
    footerLegalNoticeLink: 'Mențiuni legale',
    footerPrivacyPolicyLink: 'Date personale',
    footerRightsReserved: 'Toate drepturile rezervate.',
    footerCloseLabel: 'Închide',
    footerCookieSettingsLink: 'Setări cookie-uri',
    themeToggleDark: 'Activează modul întunecat',
    themeToggleLight: 'Activează modul luminos',
    cookieBannerMessage: 'Folosim cookie-uri și stocare locală pentru buna funcționare a site-ului și, dacă sunteți de acord, pentru a măsura audiența. Puteți accepta, refuza sau personaliza alegerile în orice moment.',
    cookieBannerAcceptAll: 'Acceptă tot',
    cookieBannerRejectAll: 'Refuză tot',
    cookieBannerCustomize: 'Personalizează',
    cookiePrefsTitle: 'Setări cookie-uri',
    cookiePrefsIntro: 'Alegeți categoriile de cookie-uri pe care doriți să le permiteți. Puteți schimba preferințele oricând din subsolul site-ului.',
    cookieCategoryNecessaryTitle: 'Cookie-uri necesare',
    cookieCategoryNecessaryDesc: 'Indispensabile pentru funcționarea site-ului, în special pentru a reține limba de navigare. Nu pot fi dezactivate.',
    cookieCategoryAnalyticsTitle: 'Măsurare audiență',
    cookieCategoryAnalyticsDesc: 'Ne ajută să înțelegem utilizarea site-ului (pagini vizualizate, sursa vizitelor) pentru a-l îmbunătăți. Dezactivate implicit.',
    cookieCategoryMarketingTitle: 'Marketing',
    cookieCategoryMarketingDesc: 'Utilizate pentru a măsura eficiența comunicărilor noastre. Dezactivate implicit și neutilizate în prezent.',
    cookiePrefsSave: 'Salvează alegerile mele',
    cookieAlwaysActive: 'Întotdeauna active',
  },
  ru: {
    distributorsTitle: 'Дистрибьюторы',
    distributorsDefaultTitle: 'Ваш дистрибьютор',
    distributorsLoading: 'Загрузка дистрибьюторов…',
    distributorsErrorPrefix: 'Ошибка:',
    distributorsErrorLoad: 'Не удалось загрузить дистрибьюторов.',
    distributorsEmpty: 'Нет дистрибьюторов для этого выбора.',
    distributorsSelectPrompt: 'Выберите тип и континент, чтобы отобразить дистрибьюторов.',
    editoTocTitle: 'Содержание',
    editoTocHistory: 'Наша история',
    collectionSearchPlaceholder: 'Поиск книги…',
    collectionSearchButton: 'Поиск',
    collectionSearchResultsFor: 'Результаты по запросу',
    editoTocAuthor: 'Автор',

    cardLabelEdito: 'Редакционная статья',

    cardPinnedHint: 'Блок развёрнут — нажмите, чтобы свернуть',

    cardUnpinnedHint: 'Блок свёрнут — нажмите, чтобы развернуть',
    editoTocThought: 'Мысль дня',
    collectionCardTitle: 'Наши книги',
    collectionSelectLabel: 'Коллекция',
    collectionLanguageLabel: 'Язык',
    collectionLoading: 'Загрузка изданий…',
    collectionErrorPrefix: 'Ошибка:',
    collectionErrorLoad: 'Не удалось загрузить издания.',
    collectionEmpty: 'Нет изданий для этого выбора.',
    collectionInProgress: 'Каталог в процессе формирования: новые книги добавляются регулярно.',
    bookNotFoundTitle: 'Книга не найдена',
    bookNotFoundMessage: 'Эта книга не существует или больше недоступна.',
    bookBackHome: 'Вернуться на главную',
    collectionAll: 'Все коллекции',
    breadcrumbHome: 'Главная',
    breadcrumbLabel: 'Навигационная цепочка',
    bookContentsTitle: 'Содержание',
    bookRelatedTitle: 'Связанные издания',
    bookTranslationsTitle: 'Доступные переводы',
    bookDistributorsTitle: 'Где найти эту книгу',
    bookViewBuyLabel: 'Посмотреть / Купить',
    bookVisitSiteLabel: 'Посетить сайт',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Другие партнёры',
    distributorLabelPublisher: 'Издатель',
    distributorLabelWorldPublisher: 'Всемирный издатель',
    distributorLabelDistributor: 'Дистрибьютор',
    distributorLabelDiffuser: 'Торговый агент',
    continentEurope: 'Европа',
    continentAmerica: 'Америка',
    continentAfrica: 'Африка',
    continentMiddleEast: 'Ближний Восток',
    continentAsia: 'Азия',
    continentOceania: 'Океания',
    scrollToTopLabel: 'Наверх',
    languageSelectorLabel: 'Язык',
    thoughtLoading: 'Загрузка мысли…',
    thoughtErrorLoad: 'Не удалось загрузить мысль.',
    thoughtErrorPrefix: 'Ошибка:',
    thoughtSubscribeTitle: 'Подпишитесь и получайте каждый день вдохновляющую мысль автора',
    thoughtSubscribeEmailPlaceholder: 'ваша@почта.ру',
    thoughtSubscribeButton: 'Подписаться',
    thoughtSubscribeSending: 'Отправка...',
    thoughtSubscribeSuccess: 'Спасибо, ваш запрос на подписку отправлен.',
    thoughtSubscribeConfirmEmail: 'Чтобы завершить регистрацию, перейдите по ссылке в письме, которое вы получите.<br/>Проверьте папку со спамом и разрешите адрес «no-reply@prosveta.com».',
    thoughtSubscribeInvalidEmail: 'Пожалуйста, введите действительный адрес электронной почты.',
    thoughtSubscribeMathQuestion: 'Анти-бот вычисление:',
    thoughtSubscribeMathPlaceholder: 'Ответ',
    thoughtSubscribeMathRequired: 'Пожалуйста, ответьте на анти-бот вычисление.',
    thoughtSubscribeMathIncorrect: 'Ответ на вычисление неверный.',
    thoughtSubscribeTooFastError: 'Пожалуйста, подождите несколько секунд перед отправкой.',
    thoughtSubscribeSpamDetected: 'Отправка заблокирована: обнаружена автоматическая активность.',
    thoughtSubscribeNetworkError: 'Не удалось подключиться к серверу. Проверьте соединение и SSL-сертификат.',
    thoughtSubscribeSubmitError: 'Не удалось отправить форму подписки.',
    thoughtCaptchaRequired: 'Пожалуйста, заполните captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Введите текст с картинки',
    thoughtCaptchaImageAlt: 'Изображение captcha',
    subscriptionsListLink: 'Ваши подписки',
    subscriptionsListIntro: 'Введите ваш адрес электронной почты: мы отправим ссылку для просмотра и управления вашими подписками.',
    subscriptionsListSubmit: 'Получить ссылку',
    subscriptionsListSent: 'Если этот адрес подписан, на него только что отправлено письмо со ссылкой на ваши подписки.',
    subscriptionsListError: 'Отправка сейчас невозможна. Повторите попытку позже.',
    subscriptionsListTooMany: 'Слишком много запросов. Повторите попытку через несколько минут.',
    subscriptionsMailSubject: 'Ваши подписки Prosveta',
    subscriptionsMailIntro: 'Здравствуйте!\n\nЧтобы просмотреть ваши подписки Prosveta и управлять ими, откройте эту ссылку:',
    subscriptionsMailIgnore: 'Если вы не отправляли этот запрос, просто проигнорируйте это письмо.',


    thoughtListenLoading: 'Загрузка…',


    thoughtListenError: 'Не удалось воспроизвести',

    thoughtListenUnavailable: 'Озвучивание недоступно',

    audioPlay: 'Воспроизвести',

    audioPause: 'Пауза',

    audioStop: 'Стоп',

    audioSeek: 'Позиция воспроизведения',

    audioSpeed: 'Скорость воспроизведения',



    contentLoading: 'Загрузка содержимого…',
    contentErrorLoad: 'Не удалось загрузить содержимое.',
    contentErrorPrefix: 'Ошибка:',
    sliderLoading: 'Загрузка слайдера…',
    sliderErrorTitle: 'Ошибка',
    sliderPrevLabel: 'Предыдущее изображение',
    sliderNextLabel: 'Следующее изображение',
    subscriptionStatusSubscribed: 'Ваша подписка подтверждена, вы начнёте получать ежедневную мысль с завтрашнего дня.',
    subscriptionStatusAlreadySubscribed: 'Вы уже подписаны на этот список.',
    subscriptionStatusGeneralError: 'Произошла ошибка.',
    subscriptionsUpdateButton: 'Обновить',
    subscriptionsDeleteAllButton: 'Удалить всё',
    subscriptionsCancelButton: 'Отмена',
    subscriptionsUpdateSuccess: 'Ваши подписки обновлены.',
    subscriptionsDeleteAllSuccess: 'Все ваши подписки удалены.',
    subscriptionsUpdateError: 'Не удалось обновить ваши подписки.',
    subscriptionsModalTitle: 'Ваши подписки',
    subscriptionsNewsletterLabel: 'Рассылка',
    subscriptionsGroupTitle: 'Подписка на ежедневную мысль',
    subscriptionsLanguageLabel: 'Языки:',
    subscriptionsFormatLabel: 'Формат:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Текст',
    footerLegalNoticeLink: 'Юридическая информация',
    footerPrivacyPolicyLink: 'Персональные данные',
    footerRightsReserved: 'Все права защищены.',
    footerCloseLabel: 'Закрыть',
    footerCookieSettingsLink: 'Настройки cookie',
    themeToggleDark: 'Включить тёмный режим',
    themeToggleLight: 'Включить светлый режим',
    cookieBannerMessage: 'Мы используем куки и локальное хранилище для корректной работы сайта, а с вашего согласия — для анализа посещаемости. Вы можете принять, отклонить или настроить свой выбор в любое время.',
    cookieBannerAcceptAll: 'Принять всё',
    cookieBannerRejectAll: 'Отклонить всё',
    cookieBannerCustomize: 'Настроить',
    cookiePrefsTitle: 'Настройки cookie',
    cookiePrefsIntro: 'Выберите категории cookie, которые вы хотите разрешить. Вы можете изменить свои настройки в любое время внизу страницы сайта.',
    cookieCategoryNecessaryTitle: 'Необходимые cookie',
    cookieCategoryNecessaryDesc: 'Необходимы для работы сайта, в частности для запоминания вашего языка. Их нельзя отключить.',
    cookieCategoryAnalyticsTitle: 'Аналитика посещаемости',
    cookieCategoryAnalyticsDesc: 'Помогают нам понять, как используется сайт (просмотренные страницы, источники переходов), чтобы улучшить его. По умолчанию отключены.',
    cookieCategoryMarketingTitle: 'Маркетинг',
    cookieCategoryMarketingDesc: 'Используются для измерения эффективности наших коммуникаций. По умолчанию отключены и в настоящее время не используются.',
    cookiePrefsSave: 'Сохранить мой выбор',
    cookieAlwaysActive: 'Всегда активны',
  },
  bg: {
    distributorsTitle: 'Дистрибутори',
    distributorsDefaultTitle: 'Вашият дистрибутор',
    distributorsLoading: 'Зареждане на дистрибуторите…',
    distributorsErrorPrefix: 'Грешка:',
    distributorsErrorLoad: 'Дистрибуторите не можаха да бъдат заредени.',
    distributorsEmpty: 'Няма дистрибутор за тази селекция.',
    distributorsSelectPrompt: 'Изберете тип и континент, за да покажете дистрибуторите.',
    editoTocTitle: 'Съдържание',
    editoTocHistory: 'Нашата история',
    collectionSearchPlaceholder: 'Търсене на книга…',
    collectionSearchButton: 'Търсене',
    collectionSearchResultsFor: 'Резултати за',
    editoTocAuthor: 'Авторът',

    cardLabelEdito: 'Редакционна статия',

    cardPinnedHint: 'Блокът е разгънат — щракнете, за да свиете',

    cardUnpinnedHint: 'Блокът е свит — щракнете, за да разгънете',
    editoTocThought: 'Мисъл за деня',
    collectionCardTitle: 'Нашите книги',
    collectionSelectLabel: 'Колекция',
    collectionLanguageLabel: 'Език',
    collectionLoading: 'Зареждане на изданията…',
    collectionErrorPrefix: 'Грешка:',
    collectionErrorLoad: 'Изданията не можаха да бъдат заредени.',
    collectionEmpty: 'Няма издания за тази селекция.',
    collectionInProgress: 'Каталогът е в процес на изграждане: редовно се добавят нови заглавия.',
    bookNotFoundTitle: 'Книгата не е намерена',
    bookNotFoundMessage: 'Тази книга не съществува или вече не е налична.',
    bookBackHome: 'Обратно към началото',
    collectionAll: 'Всички колекции',
    breadcrumbHome: 'Начало',
    breadcrumbLabel: 'Навигационна пътека',
    bookContentsTitle: 'Съдържание',
    bookRelatedTitle: 'Свързани продукти',
    bookTranslationsTitle: 'Налични преводи',
    bookDistributorsTitle: 'Къде да намерите тази книга',
    bookViewBuyLabel: 'Преглед / Купуване',
    bookVisitSiteLabel: 'Посетете сайта',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Други партньори',
    distributorLabelPublisher: 'Издател',
    distributorLabelWorldPublisher: 'Световен издател',
    distributorLabelDistributor: 'Дистрибутор',
    distributorLabelDiffuser: 'Търговски агент',
    continentEurope: 'Европа',
    continentAmerica: 'Америка',
    continentAfrica: 'Африка',
    continentMiddleEast: 'Близкият изток',
    continentAsia: 'Азия',
    continentOceania: 'Океания',
    scrollToTopLabel: 'Нагоре',
    languageSelectorLabel: 'Език',
    thoughtLoading: 'Зареждане на мисълта…',
    thoughtErrorLoad: 'Не можа да се зареди мисълта.',
    thoughtErrorPrefix: 'Грешка:',
    thoughtSubscribeTitle: 'Абонирайте се и получавайте всеки ден вдъхновяваща мисъл от автора',
    thoughtSubscribeEmailPlaceholder: 'вашият@имейл.com',
    thoughtSubscribeButton: 'Абониране',
    thoughtSubscribeSending: 'Изпращане...',
    thoughtSubscribeSuccess: 'Благодарим, заявката ви за абонамент е изпратена.',
    thoughtSubscribeConfirmEmail: 'За да завършите регистрацията си, моля, кликнете върху линка в съобщението, което ще получите.<br/>Проверете спам филтрите си и разрешете адреса „no-reply@prosveta.com".',
    thoughtSubscribeInvalidEmail: 'Моля, въведете валиден имейл адрес.',
    thoughtSubscribeMathQuestion: 'Анти-бот изчисление:',
    thoughtSubscribeMathPlaceholder: 'Отговор',
    thoughtSubscribeMathRequired: 'Моля, отговорете на анти-бот изчислението.',
    thoughtSubscribeMathIncorrect: 'Отговорът е неправилен.',
    thoughtSubscribeTooFastError: 'Моля изчакайте няколко секунди преди да изпратите.',
    thoughtSubscribeSpamDetected: 'Изпращането е блокирано: открита е автоматизирана дейност.',
    thoughtSubscribeNetworkError: 'Не може да се свърже със сървъра. Проверете връзката и SSL сертификата.',
    thoughtSubscribeSubmitError: 'Не може да се изпрати формулярът за абонамент.',
    thoughtCaptchaRequired: 'Моля, попълнете captcha.',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Въведете текста от captcha',
    thoughtCaptchaImageAlt: 'Изображение на captcha',
    subscriptionsListLink: 'Вашите абонаменти',
    subscriptionsListIntro: 'Въведете своя имейл адрес: ще ви изпратим връзка за преглед и управление на абонаментите ви.',
    subscriptionsListSubmit: 'Получаване на връзката',
    subscriptionsListSent: 'Ако този адрес е абониран, на него току-що беше изпратен имейл с връзка към абонаментите ви.',
    subscriptionsListError: 'Изпращането в момента не е възможно. Опитайте отново по-късно.',
    subscriptionsListTooMany: 'Твърде много заявки. Опитайте отново след няколко минути.',
    subscriptionsMailSubject: 'Вашите абонаменти Prosveta',
    subscriptionsMailIntro: 'Здравейте,\n\nЗа да прегледате и управлявате абонаментите си в Prosveta, отворете тази връзка:',
    subscriptionsMailIgnore: 'Ако не сте направили тази заявка, просто игнорирайте това съобщение.',


    thoughtListenLoading: 'Зареждане…',


    thoughtListenError: 'Неуспешно възпроизвеждане',

    thoughtListenUnavailable: 'Озвучаването не е налично',

    audioPlay: 'Възпроизвеждане',

    audioPause: 'Пауза',

    audioStop: 'Спри',

    audioSeek: 'Позиция на възпроизвеждане',

    audioSpeed: 'Скорост на възпроизвеждане',



    contentLoading: 'Зареждане на съдържанието…',
    contentErrorLoad: 'Не можа да се зареди съдържанието.',
    contentErrorPrefix: 'Грешка:',
    sliderLoading: 'Зареждане на слайдера…',
    sliderErrorTitle: 'Грешка',
    sliderPrevLabel: 'Предишно изображение',
    sliderNextLabel: 'Следващо изображение',
    subscriptionStatusSubscribed: 'Вашата регистрация е потвърдена, ще получавате ежедневната мисъл от утре.',
    subscriptionStatusAlreadySubscribed: 'Вече сте записани в този списък.',
    subscriptionStatusGeneralError: 'Възникна грешка.',
    subscriptionsUpdateButton: 'Актуализирай',
    subscriptionsDeleteAllButton: 'Изтрий всичко',
    subscriptionsCancelButton: 'Отказ',
    subscriptionsUpdateSuccess: 'Вашите абонаменти бяха актуализирани.',
    subscriptionsDeleteAllSuccess: 'Всички ваши абонаменти бяха премахнати.',
    subscriptionsUpdateError: 'Неуспешно актуализиране на абонаментите ви.',
    subscriptionsModalTitle: 'Вашите абонаменти',
    subscriptionsNewsletterLabel: 'Бюлетин',
    subscriptionsGroupTitle: 'Абонамент за ежедневната мисъл',
    subscriptionsLanguageLabel: 'Езици:',
    subscriptionsFormatLabel: 'Формат:',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Текст',
    footerLegalNoticeLink: 'Правна информация',
    footerPrivacyPolicyLink: 'Лични данни',
    footerRightsReserved: 'Всички права запазени.',
    footerCloseLabel: 'Затвори',
    footerCookieSettingsLink: 'Настройки на бисквитките',
    themeToggleDark: 'Включи тъмен режим',
    themeToggleLight: 'Включи светъл режим',
    cookieBannerMessage: 'Използваме бисквитки и локално съхранение, за да гарантираме доброто функциониране на сайта, а с вашето съгласие — за да измерваме посещаемостта. Можете да приемете, откажете или персонализирате избора си по всяко време.',
    cookieBannerAcceptAll: 'Приеми всички',
    cookieBannerRejectAll: 'Откажи всички',
    cookieBannerCustomize: 'Персонализирай',
    cookiePrefsTitle: 'Настройки на бисквитките',
    cookiePrefsIntro: 'Изберете категориите бисквитки, които искате да разрешите. Можете да промените предпочитанията си по всяко време от долния колонтитул на сайта.',
    cookieCategoryNecessaryTitle: 'Необходими бисквитки',
    cookieCategoryNecessaryDesc: 'Необходими за функционирането на сайта, по-специално за запомняне на вашия език. Не могат да бъдат деактивирани.',
    cookieCategoryAnalyticsTitle: 'Измерване на посещаемостта',
    cookieCategoryAnalyticsDesc: 'Помагат ни да разберем как се използва сайтът (разгледани страници, източник на посещенията), за да го подобрим. Деактивирани по подразбиране.',
    cookieCategoryMarketingTitle: 'Маркетинг',
    cookieCategoryMarketingDesc: 'Използват се за измерване на ефективността на нашите комуникации. Деактивирани по подразбиране и не се използват понастоящем.',
    cookiePrefsSave: 'Запази избора ми',
    cookieAlwaysActive: 'Винаги активни',
  },
  hy: {
    distributorsTitle: 'Տարածողներ',
    distributorsDefaultTitle: 'Ձեր տարածողը',
    distributorsLoading: 'Տարածողներու բեռնում…',
    distributorsErrorPrefix: 'Սխալ՝',
    distributorsErrorLoad: 'Կարելի չեղաւ տարածողները բեռնել։',
    distributorsEmpty: 'Այս ընտրութեան համար տարածող չկայ։',
    distributorsSelectPrompt: 'Տարածողները տեսնելու համար ընտրեցէք տեսակ մը եւ ցամաքամաս մը։',
    editoTocTitle: 'Բովանդակութիւն',
    editoTocHistory: 'Մեր պատմութիւնը',
    collectionSearchPlaceholder: 'Գիրք մը փնտռել…',
    collectionSearchButton: 'Փնտռել',
    collectionSearchResultsFor: 'Արդիւնքներ՝',
    editoTocAuthor: 'Հեղինակը',
    cardLabelEdito: 'Խմբագրական',
    cardPinnedHint: 'Բաց վահանակ — սեղմեցէք գոցելու համար',
    cardUnpinnedHint: 'Գոց վահանակ — սեղմեցէք բանալու համար',
    editoTocThought: 'Օրուան մտածումը',
    collectionCardTitle: 'Մեր գիրքերը',
    collectionSelectLabel: 'Հաւաքածոյ',
    collectionLanguageLabel: 'Լեզու',
    collectionLoading: 'Հրատարակութիւններու բեռնում…',
    collectionErrorPrefix: 'Սխալ՝',
    collectionErrorLoad: 'Կարելի չեղաւ հրատարակութիւնները բեռնել։',
    collectionEmpty: 'Այս ընտրութեան համար հրատարակութիւն չկայ։',
    collectionInProgress: 'Ցուցակը կազմութեան ընթացքին մէջ է․ նոր գիրքեր կ՚աւելցուին կանոնաւորաբար։',
    bookNotFoundTitle: 'Գիրքը չգտնուեցաւ',
    bookNotFoundMessage: 'Այս գիրքը գոյութիւն չունի կամ այլեւս մատչելի չէ։',
    bookBackHome: 'Վերադառնալ գլխաւոր էջ',
    collectionAll: 'Բոլոր հաւաքածոները',
    breadcrumbHome: 'Գլխաւոր էջ',
    breadcrumbLabel: 'Նաւարկութեան ուղի',
    bookContentsTitle: 'Բովանդակութիւն',
    bookRelatedTitle: 'Առնչուող արտադրանքներ',
    bookTranslationsTitle: 'Մատչելի թարգմանութիւններ',
    bookDistributorsTitle: 'Ո՞ւր գտնել այս գիրքը',
    bookViewBuyLabel: 'Տեսնել / Գնել',
    bookVisitSiteLabel: 'Այցելել կայքը',
    typeProsveta: 'Prosveta',
    typeCoeditor: 'Այլ գործընկերներ',
    distributorLabelPublisher: 'Հրատարակիչ',
    distributorLabelWorldPublisher: 'Համաշխարհային հրատարակիչ',
    distributorLabelDistributor: 'Տարածող',
    distributorLabelDiffuser: 'Վաճառքի գործակալ',
    continentEurope: 'Եւրոպա',
    continentAmerica: 'Ամերիկա',
    continentAfrica: 'Ափրիկէ',
    continentMiddleEast: 'Միջին Արեւելք',
    continentAsia: 'Ասիա',
    continentOceania: 'Ովկիանիա',
    scrollToTopLabel: 'Վեր բարձրանալ',
    languageSelectorLabel: 'Լեզու',
    thoughtLoading: 'Մտածումին բեռնում…',
    thoughtErrorLoad: 'Կարելի չեղաւ մտածումը բեռնել։',
    thoughtErrorPrefix: 'Սխալ՝',
    thoughtSubscribeTitle: 'Բաժանորդագրուեցէք եւ ամէն օր ստացէք հեղինակին ներշնչող մտածում մը',
    thoughtSubscribeEmailPlaceholder: 'name@email.com',
    thoughtSubscribeMathQuestion: 'Հակա-ռոպոտ հաշիւ՝',
    thoughtSubscribeMathPlaceholder: 'Պատասխան',
    thoughtSubscribeButton: 'Բաժանորդագրուիլ',
    thoughtSubscribeSending: 'Կը ղրկուի…',
    thoughtSubscribeSuccess: 'Շնորհակալութիւն, ձեր բաժանորդագրութեան խնդրանքը ղրկուեցաւ։',
    thoughtSubscribeConfirmEmail: 'Ձեր բաժանորդագրութիւնը ամբողջացնելու համար սեղմեցէք այն յղումին վրայ, որ պիտի ստանաք նամակով։<br/>Ստուգեցէք ձեր spam զտիչները եւ թոյլատրեցէք «no-reply@prosveta.com» հասցէն։',
    thoughtSubscribeInvalidEmail: 'Հաճեցէք գրել վաւերական ել-հասցէ մը։',
    thoughtSubscribeMathRequired: 'Հաճեցէք պատասխանել հակա-ռոպոտ հաշիւին։',
    thoughtSubscribeMathIncorrect: 'Հաշիւին պատասխանը սխալ է։',
    thoughtSubscribeTooFastError: 'Հաճեցէք քանի մը վայրկեան սպասել ղրկելէ առաջ։',
    thoughtSubscribeSpamDetected: 'Ղրկումը արգիլուեցաւ․ ինքնաշխատ գործունէութիւն յայտնաբերուեցաւ։',
    thoughtSubscribeNetworkError: 'Կարելի չէ կապուիլ սպասարկիչին։ Ստուգեցէք ձեր կապը եւ SSL վկայականը։',
    thoughtSubscribeSubmitError: 'Կարելի չեղաւ բաժանորդագրութեան ձեւը ղրկել։',
    thoughtCaptchaRequired: 'Հաճեցէք լրացնել captcha-ն։',
    thoughtCaptchaLabel: 'Captcha',
    thoughtCaptchaPlaceholder: 'Գրեցէք պատկերին վրայի գրութիւնը',
    thoughtCaptchaImageAlt: 'Captcha պատկեր',
    subscriptionsListLink: 'Ձեր բաժանորդագրութիւնները',
    subscriptionsListIntro: 'Գրեցէք ձեր ել-հասցէն․ ձեզի պիտի ղրկենք յղում մը՝ ձեր բաժանորդագրութիւնները տեսնելու եւ կառավարելու համար։',
    subscriptionsListSubmit: 'Ստանալ յղումը',
    subscriptionsListSent: 'Եթէ այս հասցէն բաժանորդագրուած է, անոր ղրկուեցաւ նամակ մը՝ ձեր բաժանորդագրութիւններու յղումով։',
    subscriptionsListError: 'Ղրկումը այս պահուն կարելի չէ։ Փորձեցէք աւելի ուշ։',
    subscriptionsListTooMany: 'Չափազանց շատ խնդրանքներ։ Փորձեցէք քանի մը վայրկեանէն։',
    subscriptionsMailSubject: 'Ձեր Prosveta բաժանորդագրութիւնները',
    subscriptionsMailIntro: 'Բարեւ,\n\nՁեր Prosveta բաժանորդագրութիւնները տեսնելու եւ կառավարելու համար բացէք այս յղումը՝',
    subscriptionsMailIgnore: 'Եթէ այս խնդրանքը դուք չէք ըրած, պարզապէս անտեսեցէք այս նամակը։',
    thoughtListenLoading: 'Բեռնում…',
    thoughtListenError: 'Ընթերցումը ձախողեցաւ',
    thoughtListenUnavailable: 'Ձայնային ընթերցումը մատչելի չէ',
    audioPlay: 'Ունկնդրել',
    audioPause: 'Դադար',
    audioStop: 'Կասեցնել',
    audioSeek: 'Ընթերցումին դիրքը',
    audioSpeed: 'Ընթերցումին արագութիւնը',
    contentLoading: 'Բովանդակութեան բեռնում…',
    contentErrorLoad: 'Կարելի չեղաւ բովանդակութիւնը բեռնել։',
    contentErrorPrefix: 'Սխալ՝',
    sliderLoading: 'Բեռնում…',
    sliderErrorTitle: 'Սխալ',
    sliderPrevLabel: 'Նախորդ պատկերը',
    sliderNextLabel: 'Յաջորդ պատկերը',
    subscriptionStatusSubscribed: 'Ձեր բաժանորդագրութիւնը հաստատուեցաւ․ վաղուընէ սկսեալ պիտի ստանաք օրուան մտածումը։',
    subscriptionStatusAlreadySubscribed: 'Արդէն բաժանորդագրուած էք այս ցանկին։',
    subscriptionStatusGeneralError: 'Սխալ մը պատահեցաւ։',
    subscriptionsMissingParams: 'Անվաւեր յղում․ ել-հասցէն կամ բանալին կը պակսի։',
    subscriptionsLoadError: 'Կարելի չեղաւ ձեր բաժանորդագրութիւնները բեռնել։',
    subscriptionsModalTitle: 'Ձեր բաժանորդագրութիւնները',
    subscriptionsNewsletterLabel: 'Լրատու',
    subscriptionsGroupTitle: 'Օրուան մտածումին բաժանորդագրութիւն',
    subscriptionsLanguageLabel: 'Լեզուներ՝',
    subscriptionsFormatLabel: 'Ձեւաչափ՝',
    subscriptionsFormatHtml: 'HTML',
    subscriptionsFormatText: 'Պարզ գրութիւն',
    subscriptionsUpdateButton: 'Թարմացնել',
    subscriptionsDeleteAllButton: 'Ջնջել բոլորը',
    subscriptionsCancelButton: 'Չեղարկել',
    subscriptionsUpdateSuccess: 'Ձեր բաժանորդագրութիւնները թարմացուեցան։',
    subscriptionsDeleteAllSuccess: 'Ձեր բոլոր բաժանորդագրութիւնները ջնջուեցան։',
    subscriptionsUpdateError: 'Կարելի չեղաւ ձեր բաժանորդագրութիւնները թարմացնել։',
    footerLegalNoticeLink: 'Իրաւական տեղեկութիւններ',
    footerPrivacyPolicyLink: 'Անձնական տուեալներ',
    footerRightsReserved: 'Բոլոր իրաւունքները պաշտպանուած են։',
    footerCloseLabel: 'Գոցել',
    footerCookieSettingsLink: 'Cookie-ներու կարգաւորումներ',
    themeToggleDark: 'Անցնիլ մութ ոճի',
    themeToggleLight: 'Անցնիլ լուսաւոր ոճի',
    cookieBannerMessage: 'Կը գործածենք cookie-ներ եւ տեղական պահեստ՝ կայքին բնականոն գործունէութիւնը ապահովելու, եւ ձեր համաձայնութեամբ՝ մեր այցելուներուն թիւը չափելու համար։ Կրնաք ընդունիլ, մերժել կամ ձեր ընտրութիւնները անհատականացնել որեւէ պահու։',
    cookieBannerAcceptAll: 'Ընդունիլ բոլորը',
    cookieBannerRejectAll: 'Մերժել բոլորը',
    cookieBannerCustomize: 'Անհատականացնել',
    cookiePrefsTitle: 'Cookie-ներու կարգաւորումներ',
    cookiePrefsIntro: 'Ընտրեցէք cookie-ներու այն տեսակները, որոնք կ՚ուզէք թոյլատրել։ Կրնաք ձեր նախընտրութիւնները փոխել որեւէ պահու՝ կայքին ստորոտէն։',
    cookieCategoryNecessaryTitle: 'Անհրաժեշտ cookie-ներ',
    cookieCategoryNecessaryDesc: 'Անհրաժեշտ են կայքին գործունէութեան համար, մասնաւորապէս ձեր ընտրած լեզուն յիշելու։ Կարելի չէ զանոնք անջատել։',
    cookieCategoryAnalyticsTitle: 'Վիճակագրութիւն',
    cookieCategoryAnalyticsDesc: 'Կ՚օգնեն մեզի հասկնալու, թէ ինչպէս կը գործածուի կայքը (դիտուած էջեր, այցելութեան աղբիւրներ), զայն բարելաւելու համար։ Լռելեայն անջատուած։',
    cookieCategoryMarketingTitle: 'Շուկայագիտութիւն',
    cookieCategoryMarketingDesc: 'Կը գործածուին մեր հաղորդակցութիւններուն արդիւնաւէտութիւնը չափելու համար։ Լռելեայն անջատուած եւ ներկայիս չեն գործածուիր։',
    cookiePrefsSave: 'Պահել ընտրութիւններս',
    cookieAlwaysActive: 'Միշտ գործօն',
  },
};

export const LanguageContext = React.createContext({
  lang: 'en',
  setLang: () => {},
  t: (key) => key,
});

// Toutes les langues de l'interface ont leur propre URL (/fr/, /en/, /it/, ...).
export const URL_LANGUAGES = UI_LANGUAGES.map((language) => language.code);

// Les seules langues avec du contenu réellement traduit dans public/resources/. Une URL dont la
// langue n'est pas dans cette liste (ex. /nl/) affiche quand même l'interface traduite, mais avec
// le contenu éditorial (édito, historique, Oma, slider) en anglais — voir resolveResourceLang.
export const RESOURCE_LANGUAGES = ['fr', 'en', 'de', 'it', 'es'];

// Le serveur d'API Prosveta (pensées, collections, abonnements) n'utilise pas toujours le code ISO
// de la langue de l'interface : arménien `hy` → `am` (qui est en ISO l'amharique), portugais
// `pt` → `po`. Toujours passer par toApiLanguage avant d'envoyer une langue à l'API.
const API_LANGUAGE_BY_UI = { hy: 'am', pt: 'po' };

export function toApiLanguage(lang) {
  return API_LANGUAGE_BY_UI[lang] || lang;
}

export function resolveResourceLang(lang) {
  return RESOURCE_LANGUAGES.includes(lang) ? lang : 'en';
}

export function LanguageProvider({ children, initialLang }) {
  const [lang] = React.useState(() => {
    if (initialLang && UI_TRANSLATIONS[initialLang]) {
      return initialLang;
    }

    if (typeof window === 'undefined') {
      return 'en';
    }

    if (window.overrideLanguage && UI_TRANSLATIONS[window.overrideLanguage]) {
      return window.overrideLanguage;
    }

    const stored = window.localStorage.getItem('ui-language');
    if (stored && UI_TRANSLATIONS[stored]) {
      return stored;
    }

    const browserLang = getBrowserLanguage();
    return UI_TRANSLATIONS[browserLang] ? browserLang : 'en';
  });

  // Langue affichée mémorisée (localStorage + cookie) : reprise par le serveur pour les URL sans
  // code langue (/izvor/, /book/slug…).
  React.useEffect(() => {
    savePreference(UI_LANGUAGE_KEY, lang);
  }, [lang]);

  const setLang = (nextLang) => {
    if (!UI_TRANSLATIONS[nextLang] || nextLang === lang) {
      return;
    }

    // Chaque langue a désormais sa propre URL : on navigue plutôt que de changer l'état en
    // mémoire, pour que l'URL, le <html lang>, et le contenu affiché restent cohérents.
    savePreference(UI_LANGUAGE_KEY, nextLang);
    const segments = window.location.pathname.split('/').filter(Boolean);

    if (URL_LANGUAGES.includes(segments[0])) {
      // Page d'accueil : le premier segment est la langue, on le remplace pour rester sur la même
      // page dans la nouvelle langue.
      segments[0] = nextLang;
      window.location.href = `/${segments.join('/')}/${window.location.search}`;
    } else {
      // URL sans code langue (/book/slug, /P0225FR, /izvor/…) : la préférence qui vient d'être
      // enregistrée (cookie) suffit au serveur ; on recharge la même page, sans ?language= qui
      // primerait sur elle (voir detectLanguage, server/index.mjs).
      const params = new URLSearchParams(window.location.search);
      params.delete('language');
      const query = params.toString();
      window.location.href = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
    }
  };

  const t = (key) => {
    const dict = UI_TRANSLATIONS[lang] || UI_TRANSLATIONS.en;
    return (dict && dict[key]) || UI_TRANSLATIONS.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return React.useContext(LanguageContext);
}

export function LanguageSelector() {
  const { lang, setLang } = useTranslation();

  return (
    <div className="language-selector">
      <select value={lang} onChange={(event) => setLang(event.target.value)} aria-label="Language">
        {UI_LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.name}
          </option>
        ))}
      </select>
    </div>
  );
}
